var _classCallCheck = require("/Users/Marco/Projects/Misc-web/easy-styleguide-demo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/Marco/Projects/Misc-web/easy-styleguide-demo/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/Marco/Projects/Misc-web/easy-styleguide-demo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/Marco/Projects/Misc-web/easy-styleguide-demo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/Marco/Projects/Misc-web/easy-styleguide-demo/node_modules/@babel/runtime/helpers/inherits");

!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["react-easy-styleguide"] = t() : e["react-easy-styleguide"] = t();
}(window, function () {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var i = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var i in e) {
        n.d(r, i, function (t) {
          return e[t];
        }.bind(null, i));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 7);
  }([function (e, t, n) {
    var r = n(24),
        i = "object" == typeof self && self && self.Object === Object && self,
        o = r || i || Function("return this")();
    e.exports = o;
  }, function (e, t) {
    var n = Array.isArray;
    e.exports = n;
  }, function (e, t) {
    e.exports = require("react");
  }, function (e, t, n) {
    var r = n(8),
        i = n(48),
        o = n(49),
        s = "[object Null]",
        a = "[object Undefined]",
        l = r ? r.toStringTag : void 0;

    e.exports = function (e) {
      return null == e ? void 0 === e ? a : s : l && l in Object(e) ? i(e) : o(e);
    };
  }, function (e, t) {
    e.exports = function (e) {
      return null != e && "object" == typeof e;
    };
  }, function (e, t, n) {
    var r = n(72),
        i = n(75);

    e.exports = function (e, t) {
      var n = i(e, t);
      return r(n) ? n : void 0;
    };
  }, function (e, t, n) {
    var r = n(53);

    function i(e) {
      var t = typeof e;
      return "function" === t || "object" === t && !!e;
    }

    function o(e) {
      return "string" == typeof e;
    }

    function s(e) {
      return e.split(/\s+/g).filter(function (e) {
        return 0 !== e.length;
      });
    }

    function a(e) {
      return o(e) && "" !== e ? s(e) : e && e.length ? e.reduce(function (e, t) {
        return t ? e.concat(s(t)) : e;
      }, []) : i(e) ? (t = e, Object.keys(t).reduce(function (e, n) {
        var r = t[n];
        return "function" == typeof r && (r = r()), r ? e.concat(s(n)) : e;
      }, [])) : [];
      var t;
    }

    function l(e) {
      return function (t) {
        o(t) && (t = {
          name: t
        });
        var n = (t = r({
          prefix: "",
          modifierDelimiter: "--",
          outputIsString: !1
        }, e, t)).prefix + t.name,
            s = t.modifierDelimiter,
            l = t.outputIsString;
        return function (e, t, r) {
          var o;
          i(e) ? (o = e.element, t = e.modifiers || e.modifier, r = e.extra) : o = e;
          var u = o ? n + "__" + o : n,
              c = [u].concat(a(t).map(function (e) {
            return u + s + e;
          })).concat(a(r)).join(" ").trim();
          return l ? c : {
            className: c
          };
        };
      };
    }

    var u = l({});
    u.withDefaults = l, e.exports = u;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = r(n(44)),
        o = r(n(46)),
        s = r(n(47)),
        a = r(n(51)),
        l = n(52);
    t.Layout = l.Layout;
    var u = n(147),
        c = n(148),
        p = n(27);
    t.Viewer = p.Viewer;
    var f = n(26),
        h = [];
    var d = {
      name: "Your Easy Styleguide",
      propTypes: {}
    };
    var g = [{
      name: "Default",
      slug: "default",
      props: {}
    }];
    var m,
        y = [];

    function b(e, t) {
      return (void 0 !== e && e.length > 0 ? e : g).map(function (e) {
        return Object.assign({}, e, {
          props: Object.assign({}, t || {}, e.props),
          description: o.default(e.description || ""),
          slug: a.default(e.name)
        });
      });
    }

    function v(e) {
      var t = e.propTypes,
          n = e.getDefaultProps ? e.getDefaultProps() : {};
      if (!t || !d.propTypes) return {};
      var r = Object.keys(d.propTypes);
      return Object.keys(t).reduce(function (e, i) {
        var o = t[i];
        var s;

        for (var a = 0; a < r.length; a++) {
          var _e = r[a],
              _t = d.propTypes[_e];

          if (_t === o) {
            s = {
              name: _e
            };
            break;
          }

          if (_t.isRequired === o) {
            s = {
              name: _e,
              isRequired: !0
            };
            break;
          }
        }

        return e[i] = s || {
          name: "unknown"
        }, e[i].defaultValue = n[i] ? JSON.stringify(n[i]) : void 0, e;
      }, {});
    }

    function x(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : d;
      Object.assign(d, t), e.keys().forEach(e), t.routerLink && f.setRouter(t.routerLink);
    }

    t.init = x, t.create = function (e, t) {
      return x(e, t), t.routerLink ? l.RouterLayout : l.Layout;
    }, t.register = function (e, t, n, r, i) {
      var l = s.default(e) ? e : {
        Component: e,
        propTypesComponent: e
      };
      l.propTypesComponent = l.propTypesComponent || l.Component, l.Component = l.Component || l.component;
      var u = l.propTypesComponent;
      var c;
      l.name = l.name || u.displayName || u.name, l.name === u.name && (c = l.name, y.push(c)), h.push({
        name: l.name,
        slug: a.default(l.name),
        readme: o.default(t || ""),
        propTypes: v(u),
        variations: b(n, r),
        singlePane: (!!l.Component).noStyleGuideVariations,
        Component: l.Component,
        Wrapper: i
      });
    }, t.action = function (e) {
      return function () {
        for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
          t[_key] = arguments[_key];
        }

        console.log("[ACTION]", e, t);
      };
    }, t.list = function () {
      return m && clearTimeout(m), m = setTimeout(function () {
        y.length && (console.warn("The components ".concat(y.join(", "), " do not have a name or displayName, which might result components names becoming unrecognisable in minified/mangled production code.\nEither add a displayName to the component or pass the name to the register function.")), y = []);
      }, 100), h;
    }, t.get = function (e, t) {
      var n = h.find(function (t) {
        return t.slug === e;
      });
      if (!n) return {};
      var r = t ? [n.variations.find(function (e) {
        return e.slug === t;
      })] : n.variations;
      return {
        component: n,
        variations: r
      };
    }, t.getName = function () {
      return d.name;
    }, t.ColorList = function (e) {
      var t = u.ColorList.bind(null, e);
      return t.displayName = "Colors", t.noStyleGuideVariations = !0, t;
    }, t.TypeList = function (e) {
      var t = c.TypeList.bind(null, e);
      return t.displayName = "Typography", t.noStyleGuideVariations = !0, t;
    }, t.componentPath = function (e) {
      return i.default.join("/", d.path || "/styleguide", e);
    };
  }, function (e, t, n) {
    var r = n(0).Symbol;
    e.exports = r;
  }, function (e, t, n) {
    var r = n(62),
        i = n(63),
        o = n(64),
        s = n(65),
        a = n(66);

    function l(e) {
      var t = -1,
          n = null == e ? 0 : e.length;

      for (this.clear(); ++t < n;) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }

    l.prototype.clear = r, l.prototype.delete = i, l.prototype.get = o, l.prototype.has = s, l.prototype.set = a, e.exports = l;
  }, function (e, t, n) {
    var r = n(30);

    e.exports = function (e, t) {
      for (var n = e.length; n--;) {
        if (r(e[n][0], t)) return n;
      }

      return -1;
    };
  }, function (e, t, n) {
    var r = n(5)(Object, "create");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(84);

    e.exports = function (e, t) {
      var n = e.__data__;
      return r(t) ? n["string" == typeof t ? "string" : "hash"] : n.map;
    };
  }, function (e, t, n) {
    var r = n(22),
        i = 1 / 0;

    e.exports = function (e) {
      if ("string" == typeof e || r(e)) return e;
      var t = e + "";
      return "0" == t && 1 / e == -i ? "-0" : t;
    };
  }, function (e, t, n) {
    var r = n(28),
        i = n(59),
        o = n(135),
        s = n(1);

    e.exports = function (e, t) {
      return (s(e) ? r : o)(e, i(t, 3));
    };
  }, function (e, t, n) {
    var r = n(5)(n(0), "Map");
    e.exports = r;
  }, function (e, t) {
    e.exports = function (e) {
      var t = typeof e;
      return null != e && ("object" == t || "function" == t);
    };
  }, function (e, t, n) {
    var r = n(76),
        i = n(83),
        o = n(85),
        s = n(86),
        a = n(87);

    function l(e) {
      var t = -1,
          n = null == e ? 0 : e.length;

      for (this.clear(); ++t < n;) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }

    l.prototype.clear = r, l.prototype.delete = i, l.prototype.get = o, l.prototype.has = s, l.prototype.set = a, e.exports = l;
  }, function (e, t, n) {
    var r = n(105),
        i = n(112),
        o = n(20);

    e.exports = function (e) {
      return o(e) ? r(e) : i(e);
    };
  }, function (e, t) {
    var n = 9007199254740991;

    e.exports = function (e) {
      return "number" == typeof e && e > -1 && e % 1 == 0 && e <= n;
    };
  }, function (e, t, n) {
    var r = n(31),
        i = n(19);

    e.exports = function (e) {
      return null != e && i(e.length) && !r(e);
    };
  }, function (e, t, n) {
    var r = n(1),
        i = n(22),
        o = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        s = /^\w*$/;

    e.exports = function (e, t) {
      if (r(e)) return !1;
      var n = typeof e;
      return !("number" != n && "symbol" != n && "boolean" != n && null != e && !i(e)) || s.test(e) || !o.test(e) || null != t && e in Object(t);
    };
  }, function (e, t, n) {
    var r = n(3),
        i = n(4),
        o = "[object Symbol]";

    e.exports = function (e) {
      return "symbol" == typeof e || i(e) && r(e) == o;
    };
  }, function (e, t) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (n = window);
    }

    e.exports = n;
  }, function (e, t, n) {
    (function (t) {
      var n = "object" == typeof t && t && t.Object === Object && t;
      e.exports = n;
    }).call(this, n(23));
  }, function (e, t) {
    e.exports = function (e, t) {
      return function (n) {
        return e(t(n));
      };
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = r(n(2));

    var o = function o(e) {
      var t,
          n = e.className || "";
      return e.to === window.location.pathname && (n += " " + e.activeClassName, t = e.activeStyles), i.createElement("a", {
        href: e.to,
        className: n,
        style: t
      }, e.children);
    };

    var s = function s(e) {
      return i.createElement(o, Object.assign({}, e));
    };

    s.displayName = "StyleguideLinkWrapper", t.setRouter = function (e) {
      o = e;
    }, t.default = s;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = r(n(2)),
        o = r(n(14)),
        s = n(7),
        a = n(141),
        l = new (r(n(6)).default)("styleGuideViewer");

    var u = function u(e, t, n) {
      var r = n && function (e) {
        return JSON.stringify(e, null, 2);
      }(n.props[t]) || e.defaultValue;

      return i.default.createElement("tr", {
        key: t
      }, i.default.createElement("td", null, i.default.createElement("strong", null, t, ":")), i.default.createElement("td", null, i.default.createElement("code", null, e.name, e.isRequired ? " (required)" : null)), r ? i.default.createElement("td", {
        className: "sg-current",
        title: r
      }, r === e.defaultValue && i.default.createElement("span", {
        className: "sc"
      }, "default "), i.default.createElement("code", null, r)) : i.default.createElement("td", null));
    };

    t.Viewer = function (e) {
      if (!e.component) return function () {
        return i.default.createElement("div", {
          className: "styleGuide-element styleGuide__panel"
        }, "Select a component from the menu");
      }();

      var _s$get = s.get(e.component, e.variation),
          t = _s$get.component,
          n = _s$get.variations;

      if (!t) return function () {
        return i.default.createElement("div", {
          className: "styleGuide-element styleGuide__panel"
        }, "The component you selected does not seem to exist");
      }();
      var r = t.singlePane,
          c = e.variation && n[0],
          p = c && c.description ? c.description : t.readme;
      return i.default.createElement("div", Object.assign({}, l()), i.default.createElement("section", {
        className: "styleGuide__panel"
      }, i.default.createElement("div", {
        className: "styleGuide-element"
      }, i.default.createElement("h1", null, t.name, c ? " — " + c.name : null), i.default.createElement("div", Object.assign({}, l("description"), {
        dangerouslySetInnerHTML: {
          __html: p
        }
      })), t.propTypes && Object.keys(t.propTypes).length ? i.default.createElement("table", Object.assign({}, l("propTypes")), i.default.createElement("caption", null, i.default.createElement("h2", null, "PropTypes", c ? " & props" : null)), i.default.createElement("tbody", null, o.default(t.propTypes, function (e, t) {
        return u(e, t, c);
      }))) : null)), r ? null : i.default.createElement("div", {
        className: "styleGuide-element"
      }, i.default.createElement("h2", Object.assign({}, l("variationsHeader")), c ? "Output" : "Variations", ":")), n.map(function (e) {
        return i.default.createElement(a.Variation, {
          key: t.slug + " - " + e.slug,
          variation: e,
          component: t,
          hideMeta: !!c || r
        });
      }));
    }, t.Viewer.displayName = "Viewer";
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var n = -1, r = null == e ? 0 : e.length, i = Array(r); ++n < r;) {
        i[n] = t(e[n], n, e);
      }

      return i;
    };
  }, function (e, t, n) {
    var r = n(9),
        i = n(67),
        o = n(68),
        s = n(69),
        a = n(70),
        l = n(71);

    function u(e) {
      var t = this.__data__ = new r(e);
      this.size = t.size;
    }

    u.prototype.clear = i, u.prototype.delete = o, u.prototype.get = s, u.prototype.has = a, u.prototype.set = l, e.exports = u;
  }, function (e, t) {
    e.exports = function (e, t) {
      return e === t || e != e && t != t;
    };
  }, function (e, t, n) {
    var r = n(3),
        i = n(16),
        o = "[object AsyncFunction]",
        s = "[object Function]",
        a = "[object GeneratorFunction]",
        l = "[object Proxy]";

    e.exports = function (e) {
      if (!i(e)) return !1;
      var t = r(e);
      return t == s || t == a || t == o || t == l;
    };
  }, function (e, t) {
    var n = Function.prototype.toString;

    e.exports = function (e) {
      if (null != e) {
        try {
          return n.call(e);
        } catch (e) {}

        try {
          return e + "";
        } catch (e) {}
      }

      return "";
    };
  }, function (e, t, n) {
    var r = n(88),
        i = n(4);

    e.exports = function e(t, n, o, s, a) {
      return t === n || (null == t || null == n || !i(t) && !i(n) ? t != t && n != n : r(t, n, o, s, e, a));
    };
  }, function (e, t, n) {
    var r = n(89),
        i = n(92),
        o = n(93),
        s = 1,
        a = 2;

    e.exports = function (e, t, n, l, u, c) {
      var p = n & s,
          f = e.length,
          h = t.length;
      if (f != h && !(p && h > f)) return !1;
      var d = c.get(e);
      if (d && c.get(t)) return d == t;
      var g = -1,
          m = !0,
          y = n & a ? new r() : void 0;

      for (c.set(e, t), c.set(t, e); ++g < f;) {
        var b = e[g],
            v = t[g];
        if (l) var x = p ? l(v, b, g, t, e, c) : l(b, v, g, e, t, c);

        if (void 0 !== x) {
          if (x) continue;
          m = !1;
          break;
        }

        if (y) {
          if (!i(t, function (e, t) {
            if (!o(y, t) && (b === e || u(b, e, n, l, c))) return y.push(t);
          })) {
            m = !1;
            break;
          }
        } else if (b !== v && !u(b, v, n, l, c)) {
          m = !1;
          break;
        }
      }

      return c.delete(e), c.delete(t), m;
    };
  }, function (e, t, n) {
    var r = n(107),
        i = n(4),
        o = Object.prototype,
        s = o.hasOwnProperty,
        a = o.propertyIsEnumerable,
        l = r(function () {
      return arguments;
    }()) ? r : function (e) {
      return i(e) && s.call(e, "callee") && !a.call(e, "callee");
    };
    e.exports = l;
  }, function (e, t, n) {
    (function (e) {
      var r = n(0),
          i = n(108),
          o = t && !t.nodeType && t,
          s = o && "object" == typeof e && e && !e.nodeType && e,
          a = s && s.exports === o ? r.Buffer : void 0,
          l = (a ? a.isBuffer : void 0) || i;
      e.exports = l;
    }).call(this, n(37)(e));
  }, function (e, t) {
    e.exports = function (e) {
      return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
        enumerable: !0,
        get: function get() {
          return e.l;
        }
      }), Object.defineProperty(e, "id", {
        enumerable: !0,
        get: function get() {
          return e.i;
        }
      }), e.webpackPolyfill = 1), e;
    };
  }, function (e, t) {
    var n = 9007199254740991,
        r = /^(?:0|[1-9]\d*)$/;

    e.exports = function (e, t) {
      var i = typeof e;
      return !!(t = null == t ? n : t) && ("number" == i || "symbol" != i && r.test(e)) && e > -1 && e % 1 == 0 && e < t;
    };
  }, function (e, t, n) {
    var r = n(109),
        i = n(110),
        o = n(111),
        s = o && o.isTypedArray,
        a = s ? i(s) : r;
    e.exports = a;
  }, function (e, t, n) {
    var r = n(16);

    e.exports = function (e) {
      return e == e && !r(e);
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return function (n) {
        return null != n && n[e] === t && (void 0 !== t || e in Object(n));
      };
    };
  }, function (e, t, n) {
    var r = n(43),
        i = n(13);

    e.exports = function (e, t) {
      for (var n = 0, o = (t = r(t, e)).length; null != e && n < o;) {
        e = e[i(t[n++])];
      }

      return n && n == o ? e : void 0;
    };
  }, function (e, t, n) {
    var r = n(1),
        i = n(21),
        o = n(123),
        s = n(126);

    e.exports = function (e, t) {
      return r(e) ? e : i(e, t) ? [e] : o(s(e));
    };
  }, function (e, t, n) {
    (function (e) {
      function n(e, t) {
        for (var n = 0, r = e.length - 1; r >= 0; r--) {
          var i = e[r];
          "." === i ? e.splice(r, 1) : ".." === i ? (e.splice(r, 1), n++) : n && (e.splice(r, 1), n--);
        }

        if (t) for (; n--; n) {
          e.unshift("..");
        }
        return e;
      }

      function r(e, t) {
        if (e.filter) return e.filter(t);

        for (var n = [], r = 0; r < e.length; r++) {
          t(e[r], r, e) && n.push(e[r]);
        }

        return n;
      }

      t.resolve = function () {
        for (var t = "", i = !1, o = arguments.length - 1; o >= -1 && !i; o--) {
          var s = o >= 0 ? arguments[o] : e.cwd();
          if ("string" != typeof s) throw new TypeError("Arguments to path.resolve must be strings");
          s && (t = s + "/" + t, i = "/" === s.charAt(0));
        }

        return (i ? "/" : "") + (t = n(r(t.split("/"), function (e) {
          return !!e;
        }), !i).join("/")) || ".";
      }, t.normalize = function (e) {
        var o = t.isAbsolute(e),
            s = "/" === i(e, -1);
        return (e = n(r(e.split("/"), function (e) {
          return !!e;
        }), !o).join("/")) || o || (e = "."), e && s && (e += "/"), (o ? "/" : "") + e;
      }, t.isAbsolute = function (e) {
        return "/" === e.charAt(0);
      }, t.join = function () {
        var e = Array.prototype.slice.call(arguments, 0);
        return t.normalize(r(e, function (e, t) {
          if ("string" != typeof e) throw new TypeError("Arguments to path.join must be strings");
          return e;
        }).join("/"));
      }, t.relative = function (e, n) {
        function r(e) {
          for (var t = 0; t < e.length && "" === e[t]; t++) {
            ;
          }

          for (var n = e.length - 1; n >= 0 && "" === e[n]; n--) {
            ;
          }

          return t > n ? [] : e.slice(t, n - t + 1);
        }

        e = t.resolve(e).substr(1), n = t.resolve(n).substr(1);

        for (var i = r(e.split("/")), o = r(n.split("/")), s = Math.min(i.length, o.length), a = s, l = 0; l < s; l++) {
          if (i[l] !== o[l]) {
            a = l;
            break;
          }
        }

        var u = [];

        for (l = a; l < i.length; l++) {
          u.push("..");
        }

        return (u = u.concat(o.slice(a))).join("/");
      }, t.sep = "/", t.delimiter = ":", t.dirname = function (e) {
        if ("string" != typeof e && (e += ""), 0 === e.length) return ".";

        for (var t = e.charCodeAt(0), n = 47 === t, r = -1, i = !0, o = e.length - 1; o >= 1; --o) {
          if (47 === (t = e.charCodeAt(o))) {
            if (!i) {
              r = o;
              break;
            }
          } else i = !1;
        }

        return -1 === r ? n ? "/" : "." : n && 1 === r ? "/" : e.slice(0, r);
      }, t.basename = function (e, t) {
        var n = function (e) {
          "string" != typeof e && (e += "");
          var t,
              n = 0,
              r = -1,
              i = !0;

          for (t = e.length - 1; t >= 0; --t) {
            if (47 === e.charCodeAt(t)) {
              if (!i) {
                n = t + 1;
                break;
              }
            } else -1 === r && (i = !1, r = t + 1);
          }

          return -1 === r ? "" : e.slice(n, r);
        }(e);

        return t && n.substr(-1 * t.length) === t && (n = n.substr(0, n.length - t.length)), n;
      }, t.extname = function (e) {
        "string" != typeof e && (e += "");

        for (var t = -1, n = 0, r = -1, i = !0, o = 0, s = e.length - 1; s >= 0; --s) {
          var a = e.charCodeAt(s);
          if (47 !== a) -1 === r && (i = !1, r = s + 1), 46 === a ? -1 === t ? t = s : 1 !== o && (o = 1) : -1 !== t && (o = -1);else if (!i) {
            n = s + 1;
            break;
          }
        }

        return -1 === t || -1 === r || 0 === o || 1 === o && t === r - 1 && t === n + 1 ? "" : e.slice(t, r);
      };
      var i = "b" === "ab".substr(-1) ? function (e, t, n) {
        return e.substr(t, n);
      } : function (e, t, n) {
        return t < 0 && (t = e.length + t), e.substr(t, n);
      };
    }).call(this, n(45));
  }, function (e, t) {
    var n,
        r,
        i = e.exports = {};

    function o() {
      throw new Error("setTimeout has not been defined");
    }

    function s() {
      throw new Error("clearTimeout has not been defined");
    }

    function a(e) {
      if (n === setTimeout) return setTimeout(e, 0);
      if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);

      try {
        return n(e, 0);
      } catch (t) {
        try {
          return n.call(null, e, 0);
        } catch (t) {
          return n.call(this, e, 0);
        }
      }
    }

    !function () {
      try {
        n = "function" == typeof setTimeout ? setTimeout : o;
      } catch (e) {
        n = o;
      }

      try {
        r = "function" == typeof clearTimeout ? clearTimeout : s;
      } catch (e) {
        r = s;
      }
    }();
    var l,
        u = [],
        c = !1,
        p = -1;

    function f() {
      c && l && (c = !1, l.length ? u = l.concat(u) : p = -1, u.length && h());
    }

    function h() {
      if (!c) {
        var e = a(f);
        c = !0;

        for (var t = u.length; t;) {
          for (l = u, u = []; ++p < t;) {
            l && l[p].run();
          }

          p = -1, t = u.length;
        }

        l = null, c = !1, function (e) {
          if (r === clearTimeout) return clearTimeout(e);
          if ((r === s || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);

          try {
            r(e);
          } catch (t) {
            try {
              return r.call(null, e);
            } catch (t) {
              return r.call(this, e);
            }
          }
        }(e);
      }
    }

    function d(e, t) {
      this.fun = e, this.array = t;
    }

    function g() {}

    i.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        t[n - 1] = arguments[n];
      }
      u.push(new d(e, t)), 1 !== u.length || c || a(h);
    }, d.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = g, i.addListener = g, i.once = g, i.off = g, i.removeListener = g, i.removeAllListeners = g, i.emit = g, i.prependListener = g, i.prependOnceListener = g, i.listeners = function (e) {
      return [];
    }, i.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, i.cwd = function () {
      return "/";
    }, i.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, i.umask = function () {
      return 0;
    };
  }, function (e, t, n) {
    (function (t) {
      !function (t) {
        "use strict";

        var n = {
          newline: /^\n+/,
          code: /^( {4}[^\n]+\n*)+/,
          fences: /^ {0,3}(`{3,}|~{3,})([^`~\n]*)\n(?:|([\s\S]*?)\n)(?: {0,3}\1[~`]* *(?:\n+|$)|$)/,
          hr: /^ {0,3}((?:- *){3,}|(?:_ *){3,}|(?:\* *){3,})(?:\n+|$)/,
          heading: /^ {0,3}(#{1,6}) +([^\n]*?)(?: +#+)? *(?:\n+|$)/,
          blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
          list: /^( {0,3})(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
          html: "^ {0,3}(?:<(script|pre|style)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?\\?>\\n*|<![A-Z][\\s\\S]*?>\\n*|<!\\[CDATA\\[[\\s\\S]*?\\]\\]>\\n*|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:\\n{2,}|$)|<(?!script|pre|style)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:\\n{2,}|$)|</(?!script|pre|style)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:\\n{2,}|$))",
          def: /^ {0,3}\[(label)\]: *\n? *<?([^\s>]+)>?(?:(?: +\n? *| *\n *)(title))? *(?:\n+|$)/,
          nptable: m,
          table: m,
          lheading: /^([^\n]+)\n {0,3}(=+|-+) *(?:\n+|$)/,
          _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html)[^\n]+)*)/,
          text: /^[^\n]+/
        };

        function r(e) {
          this.tokens = [], this.tokens.links = Object.create(null), this.options = e || w.defaults, this.rules = n.normal, this.options.pedantic ? this.rules = n.pedantic : this.options.gfm && (this.rules = n.gfm);
        }

        n._label = /(?!\s*\])(?:\\[\[\]]|[^\[\]])+/, n._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/, n.def = f(n.def).replace("label", n._label).replace("title", n._title).getRegex(), n.bullet = /(?:[*+-]|\d{1,9}\.)/, n.item = /^( *)(bull) ?[^\n]*(?:\n(?!\1bull ?)[^\n]*)*/, n.item = f(n.item, "gm").replace(/bull/g, n.bullet).getRegex(), n.list = f(n.list).replace(/bull/g, n.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + n.def.source + ")").getRegex(), n._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", n._comment = /<!--(?!-?>)[\s\S]*?-->/, n.html = f(n.html, "i").replace("comment", n._comment).replace("tag", n._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), n.paragraph = f(n._paragraph).replace("hr", n.hr).replace("heading", " {0,3}#{1,6} +").replace("|lheading", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}|~{3,})[^`\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|!--)").replace("tag", n._tag).getRegex(), n.blockquote = f(n.blockquote).replace("paragraph", n.paragraph).getRegex(), n.normal = y({}, n), n.gfm = y({}, n.normal, {
          nptable: /^ *([^|\n ].*\|.*)\n *([-:]+ *\|[-| :]*)(?:\n((?:.*[^>\n ].*(?:\n|$))*)\n*|$)/,
          table: /^ *\|(.+)\n *\|?( *[-:]+[-| :]*)(?:\n((?: *[^>\n ].*(?:\n|$))*)\n*|$)/
        }), n.pedantic = y({}, n.normal, {
          html: f("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", n._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
          def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
          heading: /^ *(#{1,6}) *([^\n]+?) *(?:#+ *)?(?:\n+|$)/,
          fences: m,
          paragraph: f(n.normal._paragraph).replace("hr", n.hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", n.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex()
        }), r.rules = n, r.lex = function (e, t) {
          return new r(t).lex(e);
        }, r.prototype.lex = function (e) {
          return e = e.replace(/\r\n|\r/g, "\n").replace(/\t/g, "    ").replace(/\u00a0/g, " ").replace(/\u2424/g, "\n"), this.token(e, !0);
        }, r.prototype.token = function (e, t) {
          var r, i, o, s, a, l, u, p, f, h, d, g, m, y, x, _;

          for (e = e.replace(/^ +$/gm, ""); e;) {
            if ((o = this.rules.newline.exec(e)) && (e = e.substring(o[0].length), o[0].length > 1 && this.tokens.push({
              type: "space"
            })), o = this.rules.code.exec(e)) {
              var w = this.tokens[this.tokens.length - 1];
              e = e.substring(o[0].length), w && "paragraph" === w.type ? w.text += "\n" + o[0].trimRight() : (o = o[0].replace(/^ {4}/gm, ""), this.tokens.push({
                type: "code",
                codeBlockStyle: "indented",
                text: this.options.pedantic ? o : v(o, "\n")
              }));
            } else if (o = this.rules.fences.exec(e)) e = e.substring(o[0].length), this.tokens.push({
              type: "code",
              lang: o[2] ? o[2].trim() : o[2],
              text: o[3] || ""
            });else if (o = this.rules.heading.exec(e)) e = e.substring(o[0].length), this.tokens.push({
              type: "heading",
              depth: o[1].length,
              text: o[2]
            });else if ((o = this.rules.nptable.exec(e)) && (l = {
              type: "table",
              header: b(o[1].replace(/^ *| *\| *$/g, "")),
              align: o[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
              cells: o[3] ? o[3].replace(/\n$/, "").split("\n") : []
            }).header.length === l.align.length) {
              for (e = e.substring(o[0].length), d = 0; d < l.align.length; d++) {
                /^ *-+: *$/.test(l.align[d]) ? l.align[d] = "right" : /^ *:-+: *$/.test(l.align[d]) ? l.align[d] = "center" : /^ *:-+ *$/.test(l.align[d]) ? l.align[d] = "left" : l.align[d] = null;
              }

              for (d = 0; d < l.cells.length; d++) {
                l.cells[d] = b(l.cells[d], l.header.length);
              }

              this.tokens.push(l);
            } else if (o = this.rules.hr.exec(e)) e = e.substring(o[0].length), this.tokens.push({
              type: "hr"
            });else if (o = this.rules.blockquote.exec(e)) e = e.substring(o[0].length), this.tokens.push({
              type: "blockquote_start"
            }), o = o[0].replace(/^ *> ?/gm, ""), this.token(o, t), this.tokens.push({
              type: "blockquote_end"
            });else if (o = this.rules.list.exec(e)) {
              for (e = e.substring(o[0].length), u = {
                type: "list_start",
                ordered: y = (s = o[2]).length > 1,
                start: y ? +s : "",
                loose: !1
              }, this.tokens.push(u), p = [], r = !1, m = (o = o[0].match(this.rules.item)).length, d = 0; d < m; d++) {
                h = (l = o[d]).length, ~(l = l.replace(/^ *([*+-]|\d+\.) */, "")).indexOf("\n ") && (h -= l.length, l = this.options.pedantic ? l.replace(/^ {1,4}/gm, "") : l.replace(new RegExp("^ {1," + h + "}", "gm"), "")), d !== m - 1 && (a = n.bullet.exec(o[d + 1])[0], (s.length > 1 ? 1 === a.length : a.length > 1 || this.options.smartLists && a !== s) && (e = o.slice(d + 1).join("\n") + e, d = m - 1)), i = r || /\n\n(?!\s*$)/.test(l), d !== m - 1 && (r = "\n" === l.charAt(l.length - 1), i || (i = r)), i && (u.loose = !0), _ = void 0, (x = /^\[[ xX]\] /.test(l)) && (_ = " " !== l[1], l = l.replace(/^\[[ xX]\] +/, "")), f = {
                  type: "list_item_start",
                  task: x,
                  checked: _,
                  loose: i
                }, p.push(f), this.tokens.push(f), this.token(l, !1), this.tokens.push({
                  type: "list_item_end"
                });
              }

              if (u.loose) for (m = p.length, d = 0; d < m; d++) {
                p[d].loose = !0;
              }
              this.tokens.push({
                type: "list_end"
              });
            } else if (o = this.rules.html.exec(e)) e = e.substring(o[0].length), this.tokens.push({
              type: this.options.sanitize ? "paragraph" : "html",
              pre: !this.options.sanitizer && ("pre" === o[1] || "script" === o[1] || "style" === o[1]),
              text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(o[0]) : c(o[0]) : o[0]
            });else if (t && (o = this.rules.def.exec(e))) e = e.substring(o[0].length), o[3] && (o[3] = o[3].substring(1, o[3].length - 1)), g = o[1].toLowerCase().replace(/\s+/g, " "), this.tokens.links[g] || (this.tokens.links[g] = {
              href: o[2],
              title: o[3]
            });else if ((o = this.rules.table.exec(e)) && (l = {
              type: "table",
              header: b(o[1].replace(/^ *| *\| *$/g, "")),
              align: o[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
              cells: o[3] ? o[3].replace(/\n$/, "").split("\n") : []
            }).header.length === l.align.length) {
              for (e = e.substring(o[0].length), d = 0; d < l.align.length; d++) {
                /^ *-+: *$/.test(l.align[d]) ? l.align[d] = "right" : /^ *:-+: *$/.test(l.align[d]) ? l.align[d] = "center" : /^ *:-+ *$/.test(l.align[d]) ? l.align[d] = "left" : l.align[d] = null;
              }

              for (d = 0; d < l.cells.length; d++) {
                l.cells[d] = b(l.cells[d].replace(/^ *\| *| *\| *$/g, ""), l.header.length);
              }

              this.tokens.push(l);
            } else if (o = this.rules.lheading.exec(e)) e = e.substring(o[0].length), this.tokens.push({
              type: "heading",
              depth: "=" === o[2].charAt(0) ? 1 : 2,
              text: o[1]
            });else if (t && (o = this.rules.paragraph.exec(e))) e = e.substring(o[0].length), this.tokens.push({
              type: "paragraph",
              text: "\n" === o[1].charAt(o[1].length - 1) ? o[1].slice(0, -1) : o[1]
            });else if (o = this.rules.text.exec(e)) e = e.substring(o[0].length), this.tokens.push({
              type: "text",
              text: o[0]
            });else if (e) throw new Error("Infinite loop on byte: " + e.charCodeAt(0));
          }

          return this.tokens;
        };
        var i = {
          escape: /^\\([!"#$%&'()*+,\-.\/:;<=>?@\[\]\\^_`{|}~])/,
          autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
          url: m,
          tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
          link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
          reflink: /^!?\[(label)\]\[(?!\s*\])((?:\\[\[\]]?|[^\[\]\\])+)\]/,
          nolink: /^!?\[(?!\s*\])((?:\[[^\[\]]*\]|\\[\[\]]|[^\[\]])*)\](?:\[\])?/,
          strong: /^__([^\s_])__(?!_)|^\*\*([^\s*])\*\*(?!\*)|^__([^\s][\s\S]*?[^\s])__(?!_)|^\*\*([^\s][\s\S]*?[^\s])\*\*(?!\*)/,
          em: /^_([^\s_])_(?!_)|^\*([^\s*<\[])\*(?!\*)|^_([^\s<][\s\S]*?[^\s_])_(?!_|[^\spunctuation])|^_([^\s_<][\s\S]*?[^\s])_(?!_|[^\spunctuation])|^\*([^\s<"][\s\S]*?[^\s\*])\*(?!\*|[^\spunctuation])|^\*([^\s*"<\[][\s\S]*?[^\s])\*(?!\*)/,
          code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
          br: /^( {2,}|\\)\n(?!\s*$)/,
          del: m,
          text: /^(`+|[^`])(?:[\s\S]*?(?:(?=[\\<!\[`*]|\b_|$)|[^ ](?= {2,}\n))|(?= {2,}\n))/
        };

        function o(e, t) {
          if (this.options = t || w.defaults, this.links = e, this.rules = i.normal, this.renderer = this.options.renderer || new s(), this.renderer.options = this.options, !this.links) throw new Error("Tokens array requires a `links` property.");
          this.options.pedantic ? this.rules = i.pedantic : this.options.gfm && (this.options.breaks ? this.rules = i.breaks : this.rules = i.gfm);
        }

        function s(e) {
          this.options = e || w.defaults;
        }

        function a() {}

        function l(e) {
          this.tokens = [], this.token = null, this.options = e || w.defaults, this.options.renderer = this.options.renderer || new s(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.slugger = new u();
        }

        function u() {
          this.seen = {};
        }

        function c(e, t) {
          if (t) {
            if (c.escapeTest.test(e)) return e.replace(c.escapeReplace, function (e) {
              return c.replacements[e];
            });
          } else if (c.escapeTestNoEncode.test(e)) return e.replace(c.escapeReplaceNoEncode, function (e) {
            return c.replacements[e];
          });

          return e;
        }

        function p(e) {
          return e.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/gi, function (e, t) {
            return "colon" === (t = t.toLowerCase()) ? ":" : "#" === t.charAt(0) ? "x" === t.charAt(1) ? String.fromCharCode(parseInt(t.substring(2), 16)) : String.fromCharCode(+t.substring(1)) : "";
          });
        }

        function f(e, t) {
          return e = e.source || e, t = t || "", {
            replace: function replace(t, n) {
              return n = (n = n.source || n).replace(/(^|[^\[])\^/g, "$1"), e = e.replace(t, n), this;
            },
            getRegex: function getRegex() {
              return new RegExp(e, t);
            }
          };
        }

        function h(e, t, n) {
          if (e) {
            try {
              var r = decodeURIComponent(p(n)).replace(/[^\w:]/g, "").toLowerCase();
            } catch (e) {
              return null;
            }

            if (0 === r.indexOf("javascript:") || 0 === r.indexOf("vbscript:") || 0 === r.indexOf("data:")) return null;
          }

          t && !g.test(n) && (n = function (e, t) {
            d[" " + e] || (/^[^:]+:\/*[^\/]*$/.test(e) ? d[" " + e] = e + "/" : d[" " + e] = v(e, "/", !0));
            return e = d[" " + e], "//" === t.slice(0, 2) ? e.replace(/:[\s\S]*/, ":") + t : "/" === t.charAt(0) ? e.replace(/(:\/*[^\/]*)[\s\S]*/, "$1") + t : e + t;
          }(t, n));

          try {
            n = encodeURI(n).replace(/%25/g, "%");
          } catch (e) {
            return null;
          }

          return n;
        }

        i._punctuation = "!\"#$%&'()*+,\\-./:;<=>?@\\[^_{|}~", i.em = f(i.em).replace(/punctuation/g, i._punctuation).getRegex(), i._escapes = /\\([!"#$%&'()*+,\-.\/:;<=>?@\[\]\\^_`{|}~])/g, i._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/, i._email = /[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/, i.autolink = f(i.autolink).replace("scheme", i._scheme).replace("email", i._email).getRegex(), i._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/, i.tag = f(i.tag).replace("comment", n._comment).replace("attribute", i._attribute).getRegex(), i._label = /(?:\[[^\[\]]*\]|\\.|`[^`]*`|[^\[\]\\`])*?/, i._href = /<(?:\\[<>]?|[^\s<>\\])*>|[^\s\x00-\x1f]*/, i._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/, i.link = f(i.link).replace("label", i._label).replace("href", i._href).replace("title", i._title).getRegex(), i.reflink = f(i.reflink).replace("label", i._label).getRegex(), i.normal = y({}, i), i.pedantic = y({}, i.normal, {
          strong: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
          em: /^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/,
          link: f(/^!?\[(label)\]\((.*?)\)/).replace("label", i._label).getRegex(),
          reflink: f(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", i._label).getRegex()
        }), i.gfm = y({}, i.normal, {
          escape: f(i.escape).replace("])", "~|])").getRegex(),
          _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
          url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
          _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
          del: /^~+(?=\S)([\s\S]*?\S)~+/,
          text: /^(`+|[^`])(?:[\s\S]*?(?:(?=[\\<!\[`*~]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@))|(?= {2,}\n|[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@))/
        }), i.gfm.url = f(i.gfm.url, "i").replace("email", i.gfm._extended_email).getRegex(), i.breaks = y({}, i.gfm, {
          br: f(i.br).replace("{2,}", "*").getRegex(),
          text: f(i.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
        }), o.rules = i, o.output = function (e, t, n) {
          return new o(t, n).output(e);
        }, o.prototype.output = function (e) {
          for (var t, n, r, i, s, a, l = ""; e;) {
            if (s = this.rules.escape.exec(e)) e = e.substring(s[0].length), l += c(s[1]);else if (s = this.rules.tag.exec(e)) !this.inLink && /^<a /i.test(s[0]) ? this.inLink = !0 : this.inLink && /^<\/a>/i.test(s[0]) && (this.inLink = !1), !this.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(s[0]) ? this.inRawBlock = !0 : this.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(s[0]) && (this.inRawBlock = !1), e = e.substring(s[0].length), l += this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(s[0]) : c(s[0]) : s[0];else if (s = this.rules.link.exec(e)) {
              var u = x(s[2], "()");

              if (u > -1) {
                var p = 4 + s[1].length + u;
                s[2] = s[2].substring(0, u), s[0] = s[0].substring(0, p).trim(), s[3] = "";
              }

              e = e.substring(s[0].length), this.inLink = !0, r = s[2], this.options.pedantic ? (t = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(r)) ? (r = t[1], i = t[3]) : i = "" : i = s[3] ? s[3].slice(1, -1) : "", r = r.trim().replace(/^<([\s\S]*)>$/, "$1"), l += this.outputLink(s, {
                href: o.escapes(r),
                title: o.escapes(i)
              }), this.inLink = !1;
            } else if ((s = this.rules.reflink.exec(e)) || (s = this.rules.nolink.exec(e))) {
              if (e = e.substring(s[0].length), t = (s[2] || s[1]).replace(/\s+/g, " "), !(t = this.links[t.toLowerCase()]) || !t.href) {
                l += s[0].charAt(0), e = s[0].substring(1) + e;
                continue;
              }

              this.inLink = !0, l += this.outputLink(s, t), this.inLink = !1;
            } else if (s = this.rules.strong.exec(e)) e = e.substring(s[0].length), l += this.renderer.strong(this.output(s[4] || s[3] || s[2] || s[1]));else if (s = this.rules.em.exec(e)) e = e.substring(s[0].length), l += this.renderer.em(this.output(s[6] || s[5] || s[4] || s[3] || s[2] || s[1]));else if (s = this.rules.code.exec(e)) e = e.substring(s[0].length), l += this.renderer.codespan(c(s[2].trim(), !0));else if (s = this.rules.br.exec(e)) e = e.substring(s[0].length), l += this.renderer.br();else if (s = this.rules.del.exec(e)) e = e.substring(s[0].length), l += this.renderer.del(this.output(s[1]));else if (s = this.rules.autolink.exec(e)) e = e.substring(s[0].length), r = "@" === s[2] ? "mailto:" + (n = c(this.mangle(s[1]))) : n = c(s[1]), l += this.renderer.link(r, null, n);else if (this.inLink || !(s = this.rules.url.exec(e))) {
              if (s = this.rules.text.exec(e)) e = e.substring(s[0].length), this.inRawBlock ? l += this.renderer.text(this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(s[0]) : c(s[0]) : s[0]) : l += this.renderer.text(c(this.smartypants(s[0])));else if (e) throw new Error("Infinite loop on byte: " + e.charCodeAt(0));
            } else {
              if ("@" === s[2]) r = "mailto:" + (n = c(s[0]));else {
                do {
                  a = s[0], s[0] = this.rules._backpedal.exec(s[0])[0];
                } while (a !== s[0]);

                n = c(s[0]), r = "www." === s[1] ? "http://" + n : n;
              }
              e = e.substring(s[0].length), l += this.renderer.link(r, null, n);
            }
          }

          return l;
        }, o.escapes = function (e) {
          return e ? e.replace(o.rules._escapes, "$1") : e;
        }, o.prototype.outputLink = function (e, t) {
          var n = t.href,
              r = t.title ? c(t.title) : null;
          return "!" !== e[0].charAt(0) ? this.renderer.link(n, r, this.output(e[1])) : this.renderer.image(n, r, c(e[1]));
        }, o.prototype.smartypants = function (e) {
          return this.options.smartypants ? e.replace(/---/g, "—").replace(/--/g, "–").replace(/(^|[-\u2014\/(\[{"\s])'/g, "$1‘").replace(/'/g, "’").replace(/(^|[-\u2014\/(\[{\u2018\s])"/g, "$1“").replace(/"/g, "”").replace(/\.{3}/g, "…") : e;
        }, o.prototype.mangle = function (e) {
          if (!this.options.mangle) return e;

          for (var t, n = "", r = e.length, i = 0; i < r; i++) {
            t = e.charCodeAt(i), Math.random() > .5 && (t = "x" + t.toString(16)), n += "&#" + t + ";";
          }

          return n;
        }, s.prototype.code = function (e, t, n) {
          var r = (t || "").match(/\S*/)[0];

          if (this.options.highlight) {
            var i = this.options.highlight(e, r);
            null != i && i !== e && (n = !0, e = i);
          }

          return r ? '<pre><code class="' + this.options.langPrefix + c(r, !0) + '">' + (n ? e : c(e, !0)) + "</code></pre>\n" : "<pre><code>" + (n ? e : c(e, !0)) + "</code></pre>";
        }, s.prototype.blockquote = function (e) {
          return "<blockquote>\n" + e + "</blockquote>\n";
        }, s.prototype.html = function (e) {
          return e;
        }, s.prototype.heading = function (e, t, n, r) {
          return this.options.headerIds ? "<h" + t + ' id="' + this.options.headerPrefix + r.slug(n) + '">' + e + "</h" + t + ">\n" : "<h" + t + ">" + e + "</h" + t + ">\n";
        }, s.prototype.hr = function () {
          return this.options.xhtml ? "<hr/>\n" : "<hr>\n";
        }, s.prototype.list = function (e, t, n) {
          var r = t ? "ol" : "ul";
          return "<" + r + (t && 1 !== n ? ' start="' + n + '"' : "") + ">\n" + e + "</" + r + ">\n";
        }, s.prototype.listitem = function (e) {
          return "<li>" + e + "</li>\n";
        }, s.prototype.checkbox = function (e) {
          return "<input " + (e ? 'checked="" ' : "") + 'disabled="" type="checkbox"' + (this.options.xhtml ? " /" : "") + "> ";
        }, s.prototype.paragraph = function (e) {
          return "<p>" + e + "</p>\n";
        }, s.prototype.table = function (e, t) {
          return t && (t = "<tbody>" + t + "</tbody>"), "<table>\n<thead>\n" + e + "</thead>\n" + t + "</table>\n";
        }, s.prototype.tablerow = function (e) {
          return "<tr>\n" + e + "</tr>\n";
        }, s.prototype.tablecell = function (e, t) {
          var n = t.header ? "th" : "td";
          return (t.align ? "<" + n + ' align="' + t.align + '">' : "<" + n + ">") + e + "</" + n + ">\n";
        }, s.prototype.strong = function (e) {
          return "<strong>" + e + "</strong>";
        }, s.prototype.em = function (e) {
          return "<em>" + e + "</em>";
        }, s.prototype.codespan = function (e) {
          return "<code>" + e + "</code>";
        }, s.prototype.br = function () {
          return this.options.xhtml ? "<br/>" : "<br>";
        }, s.prototype.del = function (e) {
          return "<del>" + e + "</del>";
        }, s.prototype.link = function (e, t, n) {
          if (null === (e = h(this.options.sanitize, this.options.baseUrl, e))) return n;
          var r = '<a href="' + c(e) + '"';
          return t && (r += ' title="' + t + '"'), r += ">" + n + "</a>";
        }, s.prototype.image = function (e, t, n) {
          if (null === (e = h(this.options.sanitize, this.options.baseUrl, e))) return n;
          var r = '<img src="' + e + '" alt="' + n + '"';
          return t && (r += ' title="' + t + '"'), r += this.options.xhtml ? "/>" : ">";
        }, s.prototype.text = function (e) {
          return e;
        }, a.prototype.strong = a.prototype.em = a.prototype.codespan = a.prototype.del = a.prototype.text = function (e) {
          return e;
        }, a.prototype.link = a.prototype.image = function (e, t, n) {
          return "" + n;
        }, a.prototype.br = function () {
          return "";
        }, l.parse = function (e, t) {
          return new l(t).parse(e);
        }, l.prototype.parse = function (e) {
          this.inline = new o(e.links, this.options), this.inlineText = new o(e.links, y({}, this.options, {
            renderer: new a()
          })), this.tokens = e.reverse();

          for (var t = ""; this.next();) {
            t += this.tok();
          }

          return t;
        }, l.prototype.next = function () {
          return this.token = this.tokens.pop(), this.token;
        }, l.prototype.peek = function () {
          return this.tokens[this.tokens.length - 1] || 0;
        }, l.prototype.parseText = function () {
          for (var e = this.token.text; "text" === this.peek().type;) {
            e += "\n" + this.next().text;
          }

          return this.inline.output(e);
        }, l.prototype.tok = function () {
          switch (this.token.type) {
            case "space":
              return "";

            case "hr":
              return this.renderer.hr();

            case "heading":
              return this.renderer.heading(this.inline.output(this.token.text), this.token.depth, p(this.inlineText.output(this.token.text)), this.slugger);

            case "code":
              return this.renderer.code(this.token.text, this.token.lang, this.token.escaped);

            case "table":
              var e,
                  t,
                  n,
                  r,
                  i = "",
                  o = "";

              for (n = "", e = 0; e < this.token.header.length; e++) {
                n += this.renderer.tablecell(this.inline.output(this.token.header[e]), {
                  header: !0,
                  align: this.token.align[e]
                });
              }

              for (i += this.renderer.tablerow(n), e = 0; e < this.token.cells.length; e++) {
                for (t = this.token.cells[e], n = "", r = 0; r < t.length; r++) {
                  n += this.renderer.tablecell(this.inline.output(t[r]), {
                    header: !1,
                    align: this.token.align[r]
                  });
                }

                o += this.renderer.tablerow(n);
              }

              return this.renderer.table(i, o);

            case "blockquote_start":
              for (o = ""; "blockquote_end" !== this.next().type;) {
                o += this.tok();
              }

              return this.renderer.blockquote(o);

            case "list_start":
              o = "";

              for (var s = this.token.ordered, a = this.token.start; "list_end" !== this.next().type;) {
                o += this.tok();
              }

              return this.renderer.list(o, s, a);

            case "list_item_start":
              o = "";
              var l = this.token.loose,
                  u = this.token.checked,
                  c = this.token.task;

              for (this.token.task && (o += this.renderer.checkbox(u)); "list_item_end" !== this.next().type;) {
                o += l || "text" !== this.token.type ? this.tok() : this.parseText();
              }

              return this.renderer.listitem(o, c, u);

            case "html":
              return this.renderer.html(this.token.text);

            case "paragraph":
              return this.renderer.paragraph(this.inline.output(this.token.text));

            case "text":
              return this.renderer.paragraph(this.parseText());

            default:
              var f = 'Token with "' + this.token.type + '" type was not found.';
              if (!this.options.silent) throw new Error(f);
              console.log(f);
          }
        }, u.prototype.slug = function (e) {
          var t = e.toLowerCase().trim().replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,.\/:;<=>?@[\]^`{|}~]/g, "").replace(/\s/g, "-");

          if (this.seen.hasOwnProperty(t)) {
            var n = t;

            do {
              this.seen[n]++, t = n + "-" + this.seen[n];
            } while (this.seen.hasOwnProperty(t));
          }

          return this.seen[t] = 0, t;
        }, c.escapeTest = /[&<>"']/, c.escapeReplace = /[&<>"']/g, c.replacements = {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;"
        }, c.escapeTestNoEncode = /[<>"']|&(?!#?\w+;)/, c.escapeReplaceNoEncode = /[<>"']|&(?!#?\w+;)/g;
        var d = {},
            g = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;

        function m() {}

        function y(e) {
          for (var t, n, r = 1; r < arguments.length; r++) {
            for (n in t = arguments[r]) {
              Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }
          }

          return e;
        }

        function b(e, t) {
          var n = e.replace(/\|/g, function (e, t, n) {
            for (var r = !1, i = t; --i >= 0 && "\\" === n[i];) {
              r = !r;
            }

            return r ? "|" : " |";
          }).split(/ \|/),
              r = 0;
          if (n.length > t) n.splice(t);else for (; n.length < t;) {
            n.push("");
          }

          for (; r < n.length; r++) {
            n[r] = n[r].trim().replace(/\\\|/g, "|");
          }

          return n;
        }

        function v(e, t, n) {
          if (0 === e.length) return "";

          for (var r = 0; r < e.length;) {
            var i = e.charAt(e.length - r - 1);

            if (i !== t || n) {
              if (i === t || !n) break;
              r++;
            } else r++;
          }

          return e.substr(0, e.length - r);
        }

        function x(e, t) {
          if (-1 === e.indexOf(t[1])) return -1;

          for (var n = 0, r = 0; r < e.length; r++) {
            if ("\\" === e[r]) r++;else if (e[r] === t[0]) n++;else if (e[r] === t[1] && --n < 0) return r;
          }

          return -1;
        }

        function _(e) {
          e && e.sanitize && !e.silent && console.warn("marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options");
        }

        function w(e, t, n) {
          if (null == e) throw new Error("marked(): input parameter is undefined or null");
          if ("string" != typeof e) throw new Error("marked(): input parameter is of type " + Object.prototype.toString.call(e) + ", string expected");

          if (n || "function" == typeof t) {
            n || (n = t, t = null), _(t = y({}, w.defaults, t || {}));
            var i,
                o,
                s = t.highlight,
                a = 0;

            try {
              i = r.lex(e, t);
            } catch (e) {
              return n(e);
            }

            o = i.length;

            var u = function u(e) {
              if (e) return t.highlight = s, n(e);
              var r;

              try {
                r = l.parse(i, t);
              } catch (t) {
                e = t;
              }

              return t.highlight = s, e ? n(e) : n(null, r);
            };

            if (!s || s.length < 3) return u();
            if (delete t.highlight, !o) return u();

            for (; a < i.length; a++) {
              !function (e) {
                "code" !== e.type ? --o || u() : s(e.text, e.lang, function (t, n) {
                  return t ? u(t) : null == n || n === e.text ? --o || u() : (e.text = n, e.escaped = !0, void (--o || u()));
                });
              }(i[a]);
            }
          } else try {
            return t && (t = y({}, w.defaults, t)), _(t), l.parse(r.lex(e, t), t);
          } catch (e) {
            if (e.message += "\nPlease report this to https://github.com/markedjs/marked.", (t || w.defaults).silent) return "<p>An error occurred:</p><pre>" + c(e.message + "", !0) + "</pre>";
            throw e;
          }
        }

        m.exec = m, w.options = w.setOptions = function (e) {
          return y(w.defaults, e), w;
        }, w.getDefaults = function () {
          return {
            baseUrl: null,
            breaks: !1,
            gfm: !0,
            headerIds: !0,
            headerPrefix: "",
            highlight: null,
            langPrefix: "language-",
            mangle: !0,
            pedantic: !1,
            renderer: new s(),
            sanitize: !1,
            sanitizer: null,
            silent: !1,
            smartLists: !1,
            smartypants: !1,
            xhtml: !1
          };
        }, w.defaults = w.getDefaults(), w.Parser = l, w.parser = l.parse, w.Renderer = s, w.TextRenderer = a, w.Lexer = r, w.lexer = r.lex, w.InlineLexer = o, w.inlineLexer = o.output, w.Slugger = u, w.parse = w, e.exports = w;
      }(this || "undefined" != typeof window && window);
    }).call(this, n(23));
  }, function (e, t, n) {
    var r = n(3),
        i = n(50),
        o = n(4),
        s = "[object Object]",
        a = Function.prototype,
        l = Object.prototype,
        u = a.toString,
        c = l.hasOwnProperty,
        p = u.call(Object);

    e.exports = function (e) {
      if (!o(e) || r(e) != s) return !1;
      var t = i(e);
      if (null === t) return !0;
      var n = c.call(t, "constructor") && t.constructor;
      return "function" == typeof n && n instanceof n && u.call(n) == p;
    };
  }, function (e, t, n) {
    var r = n(8),
        i = Object.prototype,
        o = i.hasOwnProperty,
        s = i.toString,
        a = r ? r.toStringTag : void 0;

    e.exports = function (e) {
      var t = o.call(e, a),
          n = e[a];

      try {
        e[a] = void 0;
        var r = !0;
      } catch (e) {}

      var i = s.call(e);
      return r && (t ? e[a] = n : delete e[a]), i;
    };
  }, function (e, t) {
    var n = Object.prototype.toString;

    e.exports = function (e) {
      return n.call(e);
    };
  }, function (e, t, n) {
    var r = n(25)(Object.getPrototypeOf, Object);
    e.exports = r;
  }, function (e, t, n) {
    var r;
    !function (i) {
      var o, s;

      function a(e) {
        return o ? o[e] : (o = n(!function () {
          var e = new Error("Cannot find module 'unicode/category/So'");
          throw e.code = "MODULE_NOT_FOUND", e;
        }()), s = ["sign", "cross", "of", "symbol", "staff", "hand", "black", "white"].map(function (e) {
          return new RegExp(e, "gi");
        }), o[e]);
      }

      function l(e, t) {
        e = e.toString(), "string" == typeof t && (t = {
          replacement: t
        }), (t = t || {}).mode = t.mode || l.defaults.mode;

        for (var n = l.defaults.modes[t.mode], r = ["replacement", "multicharmap", "charmap", "remove", "lower"], i = 0, o = r.length; i < o; i++) {
          t[c = r[i]] = c in t ? t[c] : n[c];
        }

        void 0 === t.symbols && (t.symbols = n.symbols);
        var u = [];

        for (var c in t.multicharmap) {
          if (t.multicharmap.hasOwnProperty(c)) {
            var p = c.length;
            -1 === u.indexOf(p) && u.push(p);
          }
        }

        var f,
            h,
            d,
            g = "";

        for (i = 0, o = e.length; i < o; i++) {
          if (d = e[i], !u.some(function (n) {
            var r = e.substr(i, n);
            return !!t.multicharmap[r] && (i += n - 1, d = t.multicharmap[r], !0);
          }) && (f = t.charmap[d] ? (d = t.charmap[d]).charCodeAt(0) : e.charCodeAt(i), t.symbols && (h = a(f)))) {
            d = h.name.toLowerCase();

            for (var m = 0, y = s.length; m < y; m++) {
              d = d.replace(s[m], "");
            }

            d = d.trim();
          }

          d = d.replace(/[^\w\s\-\.\_~]/g, ""), t.remove && (d = d.replace(t.remove, "")), g += d;
        }

        return g = (g = (g = g.trim()).replace(/[-\s]+/g, t.replacement)).replace(t.replacement + "$", ""), t.lower && (g = g.toLowerCase()), g;
      }

      for (var u in l.defaults = {
        mode: "pretty"
      }, l.multicharmap = l.defaults.multicharmap = {
        "<3": "love",
        "&&": "and",
        "||": "or",
        "w/": "with"
      }, l.charmap = l.defaults.charmap = {
        "À": "A",
        "Á": "A",
        "Â": "A",
        "Ã": "A",
        "Ä": "A",
        "Å": "A",
        "Æ": "AE",
        "Ç": "C",
        "È": "E",
        "É": "E",
        "Ê": "E",
        "Ë": "E",
        "Ì": "I",
        "Í": "I",
        "Î": "I",
        "Ï": "I",
        "Ð": "D",
        "Ñ": "N",
        "Ò": "O",
        "Ó": "O",
        "Ô": "O",
        "Õ": "O",
        "Ö": "O",
        "Ő": "O",
        "Ø": "O",
        "Ù": "U",
        "Ú": "U",
        "Û": "U",
        "Ü": "U",
        "Ű": "U",
        "Ý": "Y",
        "Þ": "TH",
        "ß": "ss",
        "à": "a",
        "á": "a",
        "â": "a",
        "ã": "a",
        "ä": "a",
        "å": "a",
        "æ": "ae",
        "ç": "c",
        "è": "e",
        "é": "e",
        "ê": "e",
        "ë": "e",
        "ì": "i",
        "í": "i",
        "î": "i",
        "ï": "i",
        "ð": "d",
        "ñ": "n",
        "ò": "o",
        "ó": "o",
        "ô": "o",
        "õ": "o",
        "ö": "o",
        "ő": "o",
        "ø": "o",
        "ù": "u",
        "ú": "u",
        "û": "u",
        "ü": "u",
        "ű": "u",
        "ý": "y",
        "þ": "th",
        "ÿ": "y",
        "ẞ": "SS",
        "α": "a",
        "β": "b",
        "γ": "g",
        "δ": "d",
        "ε": "e",
        "ζ": "z",
        "η": "h",
        "θ": "8",
        "ι": "i",
        "κ": "k",
        "λ": "l",
        "μ": "m",
        "ν": "n",
        "ξ": "3",
        "ο": "o",
        "π": "p",
        "ρ": "r",
        "σ": "s",
        "τ": "t",
        "υ": "y",
        "φ": "f",
        "χ": "x",
        "ψ": "ps",
        "ω": "w",
        "ά": "a",
        "έ": "e",
        "ί": "i",
        "ό": "o",
        "ύ": "y",
        "ή": "h",
        "ώ": "w",
        "ς": "s",
        "ϊ": "i",
        "ΰ": "y",
        "ϋ": "y",
        "ΐ": "i",
        "Α": "A",
        "Β": "B",
        "Γ": "G",
        "Δ": "D",
        "Ε": "E",
        "Ζ": "Z",
        "Η": "H",
        "Θ": "8",
        "Ι": "I",
        "Κ": "K",
        "Λ": "L",
        "Μ": "M",
        "Ν": "N",
        "Ξ": "3",
        "Ο": "O",
        "Π": "P",
        "Ρ": "R",
        "Σ": "S",
        "Τ": "T",
        "Υ": "Y",
        "Φ": "F",
        "Χ": "X",
        "Ψ": "PS",
        "Ω": "W",
        "Ά": "A",
        "Έ": "E",
        "Ί": "I",
        "Ό": "O",
        "Ύ": "Y",
        "Ή": "H",
        "Ώ": "W",
        "Ϊ": "I",
        "Ϋ": "Y",
        "ş": "s",
        "Ş": "S",
        "ı": "i",
        "İ": "I",
        "ğ": "g",
        "Ğ": "G",
        "а": "a",
        "б": "b",
        "в": "v",
        "г": "g",
        "д": "d",
        "е": "e",
        "ё": "yo",
        "ж": "zh",
        "з": "z",
        "и": "i",
        "й": "j",
        "к": "k",
        "л": "l",
        "м": "m",
        "н": "n",
        "о": "o",
        "п": "p",
        "р": "r",
        "с": "s",
        "т": "t",
        "у": "u",
        "ф": "f",
        "х": "h",
        "ц": "c",
        "ч": "ch",
        "ш": "sh",
        "щ": "sh",
        "ъ": "u",
        "ы": "y",
        "ь": "",
        "э": "e",
        "ю": "yu",
        "я": "ya",
        "А": "A",
        "Б": "B",
        "В": "V",
        "Г": "G",
        "Д": "D",
        "Е": "E",
        "Ё": "Yo",
        "Ж": "Zh",
        "З": "Z",
        "И": "I",
        "Й": "J",
        "К": "K",
        "Л": "L",
        "М": "M",
        "Н": "N",
        "О": "O",
        "П": "P",
        "Р": "R",
        "С": "S",
        "Т": "T",
        "У": "U",
        "Ф": "F",
        "Х": "H",
        "Ц": "C",
        "Ч": "Ch",
        "Ш": "Sh",
        "Щ": "Sh",
        "Ъ": "U",
        "Ы": "Y",
        "Ь": "",
        "Э": "E",
        "Ю": "Yu",
        "Я": "Ya",
        "Є": "Ye",
        "І": "I",
        "Ї": "Yi",
        "Ґ": "G",
        "є": "ye",
        "і": "i",
        "ї": "yi",
        "ґ": "g",
        "č": "c",
        "ď": "d",
        "ě": "e",
        "ň": "n",
        "ř": "r",
        "š": "s",
        "ť": "t",
        "ů": "u",
        "ž": "z",
        "Č": "C",
        "Ď": "D",
        "Ě": "E",
        "Ň": "N",
        "Ř": "R",
        "Š": "S",
        "Ť": "T",
        "Ů": "U",
        "Ž": "Z",
        "ą": "a",
        "ć": "c",
        "ę": "e",
        "ł": "l",
        "ń": "n",
        "ś": "s",
        "ź": "z",
        "ż": "z",
        "Ą": "A",
        "Ć": "C",
        "Ę": "E",
        "Ł": "L",
        "Ń": "N",
        "Ś": "S",
        "Ź": "Z",
        "Ż": "Z",
        "ā": "a",
        "ē": "e",
        "ģ": "g",
        "ī": "i",
        "ķ": "k",
        "ļ": "l",
        "ņ": "n",
        "ū": "u",
        "Ā": "A",
        "Ē": "E",
        "Ģ": "G",
        "Ī": "I",
        "Ķ": "K",
        "Ļ": "L",
        "Ņ": "N",
        "Ū": "U",
        "ė": "e",
        "į": "i",
        "ų": "u",
        "Ė": "E",
        "Į": "I",
        "Ų": "U",
        "ț": "t",
        "Ț": "T",
        "ţ": "t",
        "Ţ": "T",
        "ș": "s",
        "Ș": "S",
        "ă": "a",
        "Ă": "A",
        "Ạ": "A",
        "Ả": "A",
        "Ầ": "A",
        "Ấ": "A",
        "Ậ": "A",
        "Ẩ": "A",
        "Ẫ": "A",
        "Ằ": "A",
        "Ắ": "A",
        "Ặ": "A",
        "Ẳ": "A",
        "Ẵ": "A",
        "Ẹ": "E",
        "Ẻ": "E",
        "Ẽ": "E",
        "Ề": "E",
        "Ế": "E",
        "Ệ": "E",
        "Ể": "E",
        "Ễ": "E",
        "Ị": "I",
        "Ỉ": "I",
        "Ĩ": "I",
        "Ọ": "O",
        "Ỏ": "O",
        "Ồ": "O",
        "Ố": "O",
        "Ộ": "O",
        "Ổ": "O",
        "Ỗ": "O",
        "Ơ": "O",
        "Ờ": "O",
        "Ớ": "O",
        "Ợ": "O",
        "Ở": "O",
        "Ỡ": "O",
        "Ụ": "U",
        "Ủ": "U",
        "Ũ": "U",
        "Ư": "U",
        "Ừ": "U",
        "Ứ": "U",
        "Ự": "U",
        "Ử": "U",
        "Ữ": "U",
        "Ỳ": "Y",
        "Ỵ": "Y",
        "Ỷ": "Y",
        "Ỹ": "Y",
        "Đ": "D",
        "ạ": "a",
        "ả": "a",
        "ầ": "a",
        "ấ": "a",
        "ậ": "a",
        "ẩ": "a",
        "ẫ": "a",
        "ằ": "a",
        "ắ": "a",
        "ặ": "a",
        "ẳ": "a",
        "ẵ": "a",
        "ẹ": "e",
        "ẻ": "e",
        "ẽ": "e",
        "ề": "e",
        "ế": "e",
        "ệ": "e",
        "ể": "e",
        "ễ": "e",
        "ị": "i",
        "ỉ": "i",
        "ĩ": "i",
        "ọ": "o",
        "ỏ": "o",
        "ồ": "o",
        "ố": "o",
        "ộ": "o",
        "ổ": "o",
        "ỗ": "o",
        "ơ": "o",
        "ờ": "o",
        "ớ": "o",
        "ợ": "o",
        "ở": "o",
        "ỡ": "o",
        "ụ": "u",
        "ủ": "u",
        "ũ": "u",
        "ư": "u",
        "ừ": "u",
        "ứ": "u",
        "ự": "u",
        "ử": "u",
        "ữ": "u",
        "ỳ": "y",
        "ỵ": "y",
        "ỷ": "y",
        "ỹ": "y",
        "đ": "d",
        "€": "euro",
        "₢": "cruzeiro",
        "₣": "french franc",
        "£": "pound",
        "₤": "lira",
        "₥": "mill",
        "₦": "naira",
        "₧": "peseta",
        "₨": "rupee",
        "₩": "won",
        "₪": "new shequel",
        "₫": "dong",
        "₭": "kip",
        "₮": "tugrik",
        "₯": "drachma",
        "₰": "penny",
        "₱": "peso",
        "₲": "guarani",
        "₳": "austral",
        "₴": "hryvnia",
        "₵": "cedi",
        "¢": "cent",
        "¥": "yen",
        "元": "yuan",
        "円": "yen",
        "﷼": "rial",
        "₠": "ecu",
        "¤": "currency",
        "฿": "baht",
        $: "dollar",
        "₹": "indian rupee",
        "©": "(c)",
        "œ": "oe",
        "Œ": "OE",
        "∑": "sum",
        "®": "(r)",
        "†": "+",
        "“": '"',
        "”": '"',
        "‘": "'",
        "’": "'",
        "∂": "d",
        "ƒ": "f",
        "™": "tm",
        "℠": "sm",
        "…": "...",
        "˚": "o",
        "º": "o",
        "ª": "a",
        "•": "*",
        "∆": "delta",
        "∞": "infinity",
        "♥": "love",
        "&": "and",
        "|": "or",
        "<": "less",
        ">": "greater"
      }, l.defaults.modes = {
        rfc3986: {
          replacement: "-",
          symbols: !0,
          remove: null,
          lower: !0,
          charmap: l.defaults.charmap,
          multicharmap: l.defaults.multicharmap
        },
        pretty: {
          replacement: "-",
          symbols: !0,
          remove: /[.]/g,
          lower: !1,
          charmap: l.defaults.charmap,
          multicharmap: l.defaults.multicharmap
        }
      }, l.defaults.modes) {
        l.defaults.modes.hasOwnProperty(u) && (l.defaults.modes[u].symbols = !1);
      }

      void 0 === (r = function () {
        return l;
      }.apply(t, [])) || (e.exports = r);
    }();
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    },
        i = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = r(n(2)),
        s = i(n(7)),
        a = r(n(6));
    n(54);
    var l = r(n(58)),
        u = n(27),
        c = r(n(142)),
        p = new a.default("styleGuide");
    t.Layout = function (e) {
      var t = s.list(),
          n = e.variation,
          r = e.component,
          i = s.getName();
      return o.default.createElement("div", Object.assign({}, p()), o.default.createElement(l.default, {
        components: t,
        name: i,
        current: r
      }), o.default.createElement("div", Object.assign({}, p("contents")), t.length ? o.default.createElement(u.Viewer, {
        component: r,
        variation: n
      }) : o.default.createElement("div", Object.assign({}, p("panel")), "Install successfull, now go add some ", o.default.createElement("code", null, "component.info.js"), " ", "files")));
    }, t.RouterLayout = function (e) {
      return o.default.createElement(t.Layout, Object.assign({}, e.match.params));
    }, t.Layout.propTypes = {
      variation: c.default.string,
      component: c.default.string,
      match: c.default.shape({
        params: c.default.object.isRequired
      }),
      params: c.default.object
    };
  }, function (e, t, n) {
    "use strict";
    /*
    object-assign
    (c) Sindre Sorhus
    @license MIT
    */

    var r = Object.getOwnPropertySymbols,
        i = Object.prototype.hasOwnProperty,
        o = Object.prototype.propertyIsEnumerable;

    function s(e) {
      if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(e);
    }

    e.exports = function () {
      try {
        if (!Object.assign) return !1;
        var e = new String("abc");
        if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

        for (var t = {}, n = 0; n < 10; n++) {
          t["_" + String.fromCharCode(n)] = n;
        }

        if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
          return t[e];
        }).join("")) return !1;
        var r = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (e) {
          r[e] = e;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
      } catch (e) {
        return !1;
      }
    }() ? Object.assign : function (e, t) {
      for (var n, a, l = s(e), u = 1; u < arguments.length; u++) {
        for (var c in n = Object(arguments[u])) {
          i.call(n, c) && (l[c] = n[c]);
        }

        if (r) {
          a = r(n);

          for (var p = 0; p < a.length; p++) {
            o.call(n, a[p]) && (l[a[p]] = n[a[p]]);
          }
        }
      }

      return l;
    };
  }, function (e, t, n) {
    var r = n(55);
    "string" == typeof r && (r = [[e.i, r, ""]]);
    n(57)(r, {});
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (t = e.exports = n(56)(!1)).push([e.i, "@import url(https://fonts.googleapis.com/css?family=Gudea:400,400i,700);", ""]), t.push([e.i, "body{margin:0}.styleGuide{margin:0;padding:0;border:0;font-size:100%;font-family:inherit;color:inherit;vertical-align:baseline;box-sizing:border-box;min-height:100vh;background:#F9FAF9;position:relative;padding:20px 20px 20px 320px}.styleGuide-element{font-family:'Gudea', sans-serif}.styleGuide-element,.styleGuide-element td,.styleGuide-element th{margin:0;padding:0;border:0;font-size:100%;font-family:inherit;color:inherit;vertical-align:baseline;box-sizing:border-box}.styleGuide-element a{text-decoration:none;color:#0f0fda}.styleGuide-element a:hover{text-decoration:underline}.styleGuide-element ul{list-style:disc outside !important}.styleGuide-element ol{list-style:decimal outside !important}.styleGuide-element strong{font-weight:bold}.styleGuide-element em{font-style:italic}.styleGuide-element ul,.styleGuide-element ol{padding-left:1.4em;margin-top:1em;margin-bottom:1em}.styleGuide__contents{padding:0 20px;margin-top:-20px}.styleGuide__panel{margin:0;padding:0;border:0;font-size:100%;font-family:inherit;color:inherit;vertical-align:baseline;box-sizing:border-box;background-color:white;margin:20px 0;padding:20px;max-width:800px}.styleGuideNav{position:fixed;top:0;left:0;height:100vh;width:300px;padding:20px;background-color:white;overflow:auto}.styleGuideNav ul{list-style:none !important;padding:0}.styleGuideNav__title{font-size:20px;font-weight:bolder;text-align:center;text-transform:uppercase;margin-bottom:20px;display:block;color:black}.styleGuideNav__list{margin:20px 0}.styleGuideNav__list-item{margin:15px 0;background:#F9FAF9}.styleGuideNav__list-item--sub{margin:0}.styleGuideNav__variationsList{margin:0 0 0 20px}.styleGuideNav__component{border:1px solid #0f0fda;border-radius:10px;background:white;margin:5px 0;display:block;padding:10px;text-decoration:none;color:black}.styleGuideNav__component--sub{padding:5px 10px}.styleGuideNav__component.sg-active{font-weight:bold}.styleGuideViewer{color:black}.styleGuideViewer__description{color:#86918C}.styleGuideViewer__propTypes{margin:20px 0}.styleGuideViewer__propTypes caption{text-align:left;white-space:nowrap}.styleGuideViewer__propTypes td{padding:0 5px 5px 0}.styleGuideViewer__propTypes td.sg-current{color:#86918C;white-space:nowrap;max-width:400px;overflow:hidden;text-overflow:ellipsis;display:block}.styleGuideViewer__item-container{padding-top:20px;border-top:1px solid #E4E4E4;margin:10px 0 10px 0}.styleGuideViewer__variationsHeader{text-align:center;max-width:800px}.styleGuide-element{font-size:16px}.styleGuide-element h1,.styleGuide-element h2,.styleGuide-element h3{font-family:'Gudea', sans-serif;margin:0;letter-spacing:0;line-height:1.2;font-weight:bolder}.styleGuide-element h1{font-size:32px}.styleGuide-element h2{font-size:20px;margin-bottom:5px}.styleGuide-element p{margin:0 0 1.5em 0}.styleGuide-element p:last-child{margin:0}.styleGuide-element code{font-family:monospace;margin:0;padding:0;color:inherit}.styleGuide-element strong,.styleGuide-element em,.styleGuide-element b,.styleGuide-element i{font-family:'Gudea', sans-serif;margin:0;padding:0;color:inherit}.styleGuide-element .sc{font-weight:bold;font-variant:small-caps;letter-spacing:0.02em;font-size:85%}.styleGuideColorList{margin:-10px;list-style:none;padding:0;overflow:hidden}.styleGuideColorList__item{list-style:none;padding:0;margin:0;width:136px;margin:10px;float:left}.styleGuideColorList__preview{overflow:hidden;border-radius:5px;width:100%;height:90px;display:block}.styleGuideColorList__name,.styleGuideColorList__className{margin-top:5px;font-size:14px;text-align:center}.styleGuideColorList__className{display:none;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.styleGuideColorList__item:hover .styleGuideColorList__name{display:none}.styleGuideColorList__item:hover .styleGuideColorList__className{display:block}.styleGuideTypeList{margin:0;padding:0;border:0;font-size:100%;font-family:inherit;color:inherit;vertical-align:baseline;box-sizing:border-box}.styleGuideTypeList__item{margin:0;padding:0;border:0;font-size:100%;font-family:inherit;color:inherit;vertical-align:baseline;box-sizing:border-box;line-height:1;list-style-type:none;margin:10px 0;padding-bottom:10px;border-bottom:1px solid #E4E4E4;position:relative}.styleGuideTypeList__className{position:absolute;right:10px;top:50%;line-height:14px;margin-top:-7px;font-size:14px;text-align:right}\n", ""]);
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e) {
      var t = [];
      return t.toString = function () {
        return this.map(function (t) {
          var n = function (e, t) {
            var n = e[1] || "",
                r = e[3];
            if (!r) return n;

            if (t && "function" == typeof btoa) {
              var i = (s = r, a = btoa(unescape(encodeURIComponent(JSON.stringify(s)))), l = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(a), "/*# ".concat(l, " */")),
                  o = r.sources.map(function (e) {
                return "/*# sourceURL=".concat(r.sourceRoot).concat(e, " */");
              });
              return [n].concat(o).concat([i]).join("\n");
            }

            var s, a, l;
            return [n].join("\n");
          }(t, e);

          return t[2] ? "@media ".concat(t[2], "{").concat(n, "}") : n;
        }).join("");
      }, t.i = function (e, n) {
        "string" == typeof e && (e = [[null, e, ""]]);

        for (var r = {}, i = 0; i < this.length; i++) {
          var o = this[i][0];
          null != o && (r[o] = !0);
        }

        for (var s = 0; s < e.length; s++) {
          var a = e[s];
          null != a[0] && r[a[0]] || (n && !a[2] ? a[2] = n : n && (a[2] = "(".concat(a[2], ") and (").concat(n, ")")), t.push(a));
        }
      }, t;
    };
  }, function (e, t) {
    var n = {},
        r = function r(e) {
      var t;
      return function () {
        return void 0 === t && (t = e.apply(this, arguments)), t;
      };
    },
        i = r(function () {
      return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
    }),
        o = r(function () {
      return document.head || document.getElementsByTagName("head")[0];
    }),
        s = null,
        a = 0,
        l = [];

    function u(e, t) {
      for (var r = 0; r < e.length; r++) {
        var i = e[r],
            o = n[i.id];

        if (o) {
          o.refs++;

          for (var s = 0; s < o.parts.length; s++) {
            o.parts[s](i.parts[s]);
          }

          for (; s < i.parts.length; s++) {
            o.parts.push(d(i.parts[s], t));
          }
        } else {
          var a = [];

          for (s = 0; s < i.parts.length; s++) {
            a.push(d(i.parts[s], t));
          }

          n[i.id] = {
            id: i.id,
            refs: 1,
            parts: a
          };
        }
      }
    }

    function c(e) {
      for (var t = [], n = {}, r = 0; r < e.length; r++) {
        var i = e[r],
            o = i[0],
            s = {
          css: i[1],
          media: i[2],
          sourceMap: i[3]
        };
        n[o] ? n[o].parts.push(s) : t.push(n[o] = {
          id: o,
          parts: [s]
        });
      }

      return t;
    }

    function p(e, t) {
      var n = o(),
          r = l[l.length - 1];
      if ("top" === e.insertAt) r ? r.nextSibling ? n.insertBefore(t, r.nextSibling) : n.appendChild(t) : n.insertBefore(t, n.firstChild), l.push(t);else {
        if ("bottom" !== e.insertAt) throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
        n.appendChild(t);
      }
    }

    function f(e) {
      e.parentNode.removeChild(e);
      var t = l.indexOf(e);
      t >= 0 && l.splice(t, 1);
    }

    function h(e) {
      var t = document.createElement("style");
      return t.type = "text/css", p(e, t), t;
    }

    function d(e, t) {
      var n, r, i;

      if (t.singleton) {
        var o = a++;
        n = s || (s = h(t)), r = y.bind(null, n, o, !1), i = y.bind(null, n, o, !0);
      } else e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (n = function (e) {
        var t = document.createElement("link");
        return t.rel = "stylesheet", p(e, t), t;
      }(t), r = v.bind(null, n), i = function i() {
        f(n), n.href && URL.revokeObjectURL(n.href);
      }) : (n = h(t), r = b.bind(null, n), i = function i() {
        f(n);
      });

      return r(e), function (t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          r(e = t);
        } else i();
      };
    }

    e.exports = function (e, t) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      void 0 === (t = t || {}).singleton && (t.singleton = i()), void 0 === t.insertAt && (t.insertAt = "bottom");
      var r = c(e);
      return u(r, t), function (e) {
        for (var i = [], o = 0; o < r.length; o++) {
          var s = r[o];
          (a = n[s.id]).refs--, i.push(a);
        }

        e && u(c(e), t);

        for (o = 0; o < i.length; o++) {
          var a;

          if (0 === (a = i[o]).refs) {
            for (var l = 0; l < a.parts.length; l++) {
              a.parts[l]();
            }

            delete n[a.id];
          }
        }
      };
    };

    var g,
        m = (g = [], function (e, t) {
      return g[e] = t, g.filter(Boolean).join("\n");
    });

    function y(e, t, n, r) {
      var i = n ? "" : r.css;
      if (e.styleSheet) e.styleSheet.cssText = m(t, i);else {
        var o = document.createTextNode(i),
            s = e.childNodes;
        s[t] && e.removeChild(s[t]), s.length ? e.insertBefore(o, s[t]) : e.appendChild(o);
      }
    }

    function b(e, t) {
      var n = t.css,
          r = t.media;
      if (r && e.setAttribute("media", r), e.styleSheet) e.styleSheet.cssText = n;else {
        for (; e.firstChild;) {
          e.removeChild(e.firstChild);
        }

        e.appendChild(document.createTextNode(n));
      }
    }

    function v(e, t) {
      var n = t.css,
          r = t.sourceMap;
      r && (n += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(r)))) + " */");
      var i = new Blob([n], {
        type: "text/css"
      }),
          o = e.href;
      e.href = URL.createObjectURL(i), o && URL.revokeObjectURL(o);
    }
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(n(2)),
        o = r(n(6)),
        s = n(7),
        a = r(n(26)),
        l = new o.default("styleGuideNav"),
        u = function u(_ref, o) {
      var e = _ref.slug,
          t = _ref.name,
          n = _ref.variations,
          r = _ref.singlePane;
      return i.default.createElement("li", Object.assign({
        key: e
      }, l("list-item")), i.default.createElement(a.default, Object.assign({
        to: 1 === n.length ? s.componentPath([e, n[0].slug].join("/")) : s.componentPath(e),
        activeClassName: "sg-active"
      }, l("component")), t), o !== e || r ? null : function (e, t) {
        return e.length < 2 ? null : i.default.createElement("ul", Object.assign({}, l("variationsList")), e.map(function (e) {
          return i.default.createElement("li", Object.assign({
            key: e.slug
          }, l("list-item", "sub")), i.default.createElement(a.default, Object.assign({
            to: s.componentPath(t + "/" + e.slug),
            activeClassName: "sg-active"
          }, l("component", "sub")), e.name));
        }));
      }(n, e));
    };

    t.default = function (_ref2) {
      var e = _ref2.components,
          t = _ref2.name,
          n = _ref2.current;
      return i.default.createElement("nav", Object.assign({}, l({
        extra: "styleGuide-element"
      })), i.default.createElement(a.default, Object.assign({
        to: s.componentPath("")
      }, l("title")), t), i.default.createElement("ul", Object.assign({}, l("list")), e.map(function (e) {
        return u(e, n);
      })));
    };
  }, function (e, t, n) {
    var r = n(60),
        i = n(121),
        o = n(131),
        s = n(1),
        a = n(132);

    e.exports = function (e) {
      return "function" == typeof e ? e : null == e ? o : "object" == typeof e ? s(e) ? i(e[0], e[1]) : r(e) : a(e);
    };
  }, function (e, t, n) {
    var r = n(61),
        i = n(120),
        o = n(41);

    e.exports = function (e) {
      var t = i(e);
      return 1 == t.length && t[0][2] ? o(t[0][0], t[0][1]) : function (n) {
        return n === e || r(n, e, t);
      };
    };
  }, function (e, t, n) {
    var r = n(29),
        i = n(33),
        o = 1,
        s = 2;

    e.exports = function (e, t, n, a) {
      var l = n.length,
          u = l,
          c = !a;
      if (null == e) return !u;

      for (e = Object(e); l--;) {
        var p = n[l];
        if (c && p[2] ? p[1] !== e[p[0]] : !(p[0] in e)) return !1;
      }

      for (; ++l < u;) {
        var f = (p = n[l])[0],
            h = e[f],
            d = p[1];

        if (c && p[2]) {
          if (void 0 === h && !(f in e)) return !1;
        } else {
          var g = new r();
          if (a) var m = a(h, d, f, e, t, g);
          if (!(void 0 === m ? i(d, h, o | s, a, g) : m)) return !1;
        }
      }

      return !0;
    };
  }, function (e, t) {
    e.exports = function () {
      this.__data__ = [], this.size = 0;
    };
  }, function (e, t, n) {
    var r = n(10),
        i = Array.prototype.splice;

    e.exports = function (e) {
      var t = this.__data__,
          n = r(t, e);
      return !(n < 0) && (n == t.length - 1 ? t.pop() : i.call(t, n, 1), --this.size, !0);
    };
  }, function (e, t, n) {
    var r = n(10);

    e.exports = function (e) {
      var t = this.__data__,
          n = r(t, e);
      return n < 0 ? void 0 : t[n][1];
    };
  }, function (e, t, n) {
    var r = n(10);

    e.exports = function (e) {
      return r(this.__data__, e) > -1;
    };
  }, function (e, t, n) {
    var r = n(10);

    e.exports = function (e, t) {
      var n = this.__data__,
          i = r(n, e);
      return i < 0 ? (++this.size, n.push([e, t])) : n[i][1] = t, this;
    };
  }, function (e, t, n) {
    var r = n(9);

    e.exports = function () {
      this.__data__ = new r(), this.size = 0;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = this.__data__,
          n = t.delete(e);
      return this.size = t.size, n;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return this.__data__.get(e);
    };
  }, function (e, t) {
    e.exports = function (e) {
      return this.__data__.has(e);
    };
  }, function (e, t, n) {
    var r = n(9),
        i = n(15),
        o = n(17),
        s = 200;

    e.exports = function (e, t) {
      var n = this.__data__;

      if (n instanceof r) {
        var a = n.__data__;
        if (!i || a.length < s - 1) return a.push([e, t]), this.size = ++n.size, this;
        n = this.__data__ = new o(a);
      }

      return n.set(e, t), this.size = n.size, this;
    };
  }, function (e, t, n) {
    var r = n(31),
        i = n(73),
        o = n(16),
        s = n(32),
        a = /^\[object .+?Constructor\]$/,
        l = Function.prototype,
        u = Object.prototype,
        c = l.toString,
        p = u.hasOwnProperty,
        f = RegExp("^" + c.call(p).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

    e.exports = function (e) {
      return !(!o(e) || i(e)) && (r(e) ? f : a).test(s(e));
    };
  }, function (e, t, n) {
    var r,
        i = n(74),
        o = (r = /[^.]+$/.exec(i && i.keys && i.keys.IE_PROTO || "")) ? "Symbol(src)_1." + r : "";

    e.exports = function (e) {
      return !!o && o in e;
    };
  }, function (e, t, n) {
    var r = n(0)["__core-js_shared__"];
    e.exports = r;
  }, function (e, t) {
    e.exports = function (e, t) {
      return null == e ? void 0 : e[t];
    };
  }, function (e, t, n) {
    var r = n(77),
        i = n(9),
        o = n(15);

    e.exports = function () {
      this.size = 0, this.__data__ = {
        hash: new r(),
        map: new (o || i)(),
        string: new r()
      };
    };
  }, function (e, t, n) {
    var r = n(78),
        i = n(79),
        o = n(80),
        s = n(81),
        a = n(82);

    function l(e) {
      var t = -1,
          n = null == e ? 0 : e.length;

      for (this.clear(); ++t < n;) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }

    l.prototype.clear = r, l.prototype.delete = i, l.prototype.get = o, l.prototype.has = s, l.prototype.set = a, e.exports = l;
  }, function (e, t, n) {
    var r = n(11);

    e.exports = function () {
      this.__data__ = r ? r(null) : {}, this.size = 0;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = this.has(e) && delete this.__data__[e];
      return this.size -= t ? 1 : 0, t;
    };
  }, function (e, t, n) {
    var r = n(11),
        i = "__lodash_hash_undefined__",
        o = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      var t = this.__data__;

      if (r) {
        var n = t[e];
        return n === i ? void 0 : n;
      }

      return o.call(t, e) ? t[e] : void 0;
    };
  }, function (e, t, n) {
    var r = n(11),
        i = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      var t = this.__data__;
      return r ? void 0 !== t[e] : i.call(t, e);
    };
  }, function (e, t, n) {
    var r = n(11),
        i = "__lodash_hash_undefined__";

    e.exports = function (e, t) {
      var n = this.__data__;
      return this.size += this.has(e) ? 0 : 1, n[e] = r && void 0 === t ? i : t, this;
    };
  }, function (e, t, n) {
    var r = n(12);

    e.exports = function (e) {
      var t = r(this, e).delete(e);
      return this.size -= t ? 1 : 0, t;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = typeof e;
      return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
    };
  }, function (e, t, n) {
    var r = n(12);

    e.exports = function (e) {
      return r(this, e).get(e);
    };
  }, function (e, t, n) {
    var r = n(12);

    e.exports = function (e) {
      return r(this, e).has(e);
    };
  }, function (e, t, n) {
    var r = n(12);

    e.exports = function (e, t) {
      var n = r(this, e),
          i = n.size;
      return n.set(e, t), this.size += n.size == i ? 0 : 1, this;
    };
  }, function (e, t, n) {
    var r = n(29),
        i = n(34),
        o = n(94),
        s = n(98),
        a = n(115),
        l = n(1),
        u = n(36),
        c = n(39),
        p = 1,
        f = "[object Arguments]",
        h = "[object Array]",
        d = "[object Object]",
        g = Object.prototype.hasOwnProperty;

    e.exports = function (e, t, n, m, y, b) {
      var v = l(e),
          x = l(t),
          _ = v ? h : a(e),
          w = x ? h : a(t),
          k = (_ = _ == f ? d : _) == d,
          j = (w = w == f ? d : w) == d,
          O = _ == w;

      if (O && u(e)) {
        if (!u(t)) return !1;
        v = !0, k = !1;
      }

      if (O && !k) return b || (b = new r()), v || c(e) ? i(e, t, n, m, y, b) : o(e, t, _, n, m, y, b);

      if (!(n & p)) {
        var E = k && g.call(e, "__wrapped__"),
            A = j && g.call(t, "__wrapped__");

        if (E || A) {
          var S = E ? e.value() : e,
              T = A ? t.value() : t;
          return b || (b = new r()), y(S, T, n, m, b);
        }
      }

      return !!O && (b || (b = new r()), s(e, t, n, m, y, b));
    };
  }, function (e, t, n) {
    var r = n(17),
        i = n(90),
        o = n(91);

    function s(e) {
      var t = -1,
          n = null == e ? 0 : e.length;

      for (this.__data__ = new r(); ++t < n;) {
        this.add(e[t]);
      }
    }

    s.prototype.add = s.prototype.push = i, s.prototype.has = o, e.exports = s;
  }, function (e, t) {
    var n = "__lodash_hash_undefined__";

    e.exports = function (e) {
      return this.__data__.set(e, n), this;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return this.__data__.has(e);
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var n = -1, r = null == e ? 0 : e.length; ++n < r;) {
        if (t(e[n], n, e)) return !0;
      }

      return !1;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return e.has(t);
    };
  }, function (e, t, n) {
    var r = n(8),
        i = n(95),
        o = n(30),
        s = n(34),
        a = n(96),
        l = n(97),
        u = 1,
        c = 2,
        p = "[object Boolean]",
        f = "[object Date]",
        h = "[object Error]",
        d = "[object Map]",
        g = "[object Number]",
        m = "[object RegExp]",
        y = "[object Set]",
        b = "[object String]",
        v = "[object Symbol]",
        x = "[object ArrayBuffer]",
        _ = "[object DataView]",
        w = r ? r.prototype : void 0,
        k = w ? w.valueOf : void 0;

    e.exports = function (e, t, n, r, w, j, O) {
      switch (n) {
        case _:
          if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
          e = e.buffer, t = t.buffer;

        case x:
          return !(e.byteLength != t.byteLength || !j(new i(e), new i(t)));

        case p:
        case f:
        case g:
          return o(+e, +t);

        case h:
          return e.name == t.name && e.message == t.message;

        case m:
        case b:
          return e == t + "";

        case d:
          var E = a;

        case y:
          var A = r & u;
          if (E || (E = l), e.size != t.size && !A) return !1;
          var S = O.get(e);
          if (S) return S == t;
          r |= c, O.set(e, t);
          var T = s(E(e), E(t), r, w, j, O);
          return O.delete(e), T;

        case v:
          if (k) return k.call(e) == k.call(t);
      }

      return !1;
    };
  }, function (e, t, n) {
    var r = n(0).Uint8Array;
    e.exports = r;
  }, function (e, t) {
    e.exports = function (e) {
      var t = -1,
          n = Array(e.size);
      return e.forEach(function (e, r) {
        n[++t] = [r, e];
      }), n;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = -1,
          n = Array(e.size);
      return e.forEach(function (e) {
        n[++t] = e;
      }), n;
    };
  }, function (e, t, n) {
    var r = n(99),
        i = 1,
        o = Object.prototype.hasOwnProperty;

    e.exports = function (e, t, n, s, a, l) {
      var u = n & i,
          c = r(e),
          p = c.length;
      if (p != r(t).length && !u) return !1;

      for (var f = p; f--;) {
        var h = c[f];
        if (!(u ? h in t : o.call(t, h))) return !1;
      }

      var d = l.get(e);
      if (d && l.get(t)) return d == t;
      var g = !0;
      l.set(e, t), l.set(t, e);

      for (var m = u; ++f < p;) {
        var y = e[h = c[f]],
            b = t[h];
        if (s) var v = u ? s(b, y, h, t, e, l) : s(y, b, h, e, t, l);

        if (!(void 0 === v ? y === b || a(y, b, n, s, l) : v)) {
          g = !1;
          break;
        }

        m || (m = "constructor" == h);
      }

      if (g && !m) {
        var x = e.constructor,
            _ = t.constructor;
        x != _ && "constructor" in e && "constructor" in t && !("function" == typeof x && x instanceof x && "function" == typeof _ && _ instanceof _) && (g = !1);
      }

      return l.delete(e), l.delete(t), g;
    };
  }, function (e, t, n) {
    var r = n(100),
        i = n(102),
        o = n(18);

    e.exports = function (e) {
      return r(e, o, i);
    };
  }, function (e, t, n) {
    var r = n(101),
        i = n(1);

    e.exports = function (e, t, n) {
      var o = t(e);
      return i(e) ? o : r(o, n(e));
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var n = -1, r = t.length, i = e.length; ++n < r;) {
        e[i + n] = t[n];
      }

      return e;
    };
  }, function (e, t, n) {
    var r = n(103),
        i = n(104),
        o = Object.prototype.propertyIsEnumerable,
        s = Object.getOwnPropertySymbols,
        a = s ? function (e) {
      return null == e ? [] : (e = Object(e), r(s(e), function (t) {
        return o.call(e, t);
      }));
    } : i;
    e.exports = a;
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var n = -1, r = null == e ? 0 : e.length, i = 0, o = []; ++n < r;) {
        var s = e[n];
        t(s, n, e) && (o[i++] = s);
      }

      return o;
    };
  }, function (e, t) {
    e.exports = function () {
      return [];
    };
  }, function (e, t, n) {
    var r = n(106),
        i = n(35),
        o = n(1),
        s = n(36),
        a = n(38),
        l = n(39),
        u = Object.prototype.hasOwnProperty;

    e.exports = function (e, t) {
      var n = o(e),
          c = !n && i(e),
          p = !n && !c && s(e),
          f = !n && !c && !p && l(e),
          h = n || c || p || f,
          d = h ? r(e.length, String) : [],
          g = d.length;

      for (var m in e) {
        !t && !u.call(e, m) || h && ("length" == m || p && ("offset" == m || "parent" == m) || f && ("buffer" == m || "byteLength" == m || "byteOffset" == m) || a(m, g)) || d.push(m);
      }

      return d;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var n = -1, r = Array(e); ++n < e;) {
        r[n] = t(n);
      }

      return r;
    };
  }, function (e, t, n) {
    var r = n(3),
        i = n(4),
        o = "[object Arguments]";

    e.exports = function (e) {
      return i(e) && r(e) == o;
    };
  }, function (e, t) {
    e.exports = function () {
      return !1;
    };
  }, function (e, t, n) {
    var r = n(3),
        i = n(19),
        o = n(4),
        s = {};
    s["[object Float32Array]"] = s["[object Float64Array]"] = s["[object Int8Array]"] = s["[object Int16Array]"] = s["[object Int32Array]"] = s["[object Uint8Array]"] = s["[object Uint8ClampedArray]"] = s["[object Uint16Array]"] = s["[object Uint32Array]"] = !0, s["[object Arguments]"] = s["[object Array]"] = s["[object ArrayBuffer]"] = s["[object Boolean]"] = s["[object DataView]"] = s["[object Date]"] = s["[object Error]"] = s["[object Function]"] = s["[object Map]"] = s["[object Number]"] = s["[object Object]"] = s["[object RegExp]"] = s["[object Set]"] = s["[object String]"] = s["[object WeakMap]"] = !1, e.exports = function (e) {
      return o(e) && i(e.length) && !!s[r(e)];
    };
  }, function (e, t) {
    e.exports = function (e) {
      return function (t) {
        return e(t);
      };
    };
  }, function (e, t, n) {
    (function (e) {
      var r = n(24),
          i = t && !t.nodeType && t,
          o = i && "object" == typeof e && e && !e.nodeType && e,
          s = o && o.exports === i && r.process,
          a = function () {
        try {
          var e = o && o.require && o.require("util").types;

          return e || s && s.binding && s.binding("util");
        } catch (e) {}
      }();

      e.exports = a;
    }).call(this, n(37)(e));
  }, function (e, t, n) {
    var r = n(113),
        i = n(114),
        o = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      if (!r(e)) return i(e);
      var t = [];

      for (var n in Object(e)) {
        o.call(e, n) && "constructor" != n && t.push(n);
      }

      return t;
    };
  }, function (e, t) {
    var n = Object.prototype;

    e.exports = function (e) {
      var t = e && e.constructor;
      return e === ("function" == typeof t && t.prototype || n);
    };
  }, function (e, t, n) {
    var r = n(25)(Object.keys, Object);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(116),
        i = n(15),
        o = n(117),
        s = n(118),
        a = n(119),
        l = n(3),
        u = n(32),
        c = u(r),
        p = u(i),
        f = u(o),
        h = u(s),
        d = u(a),
        g = l;
    (r && "[object DataView]" != g(new r(new ArrayBuffer(1))) || i && "[object Map]" != g(new i()) || o && "[object Promise]" != g(o.resolve()) || s && "[object Set]" != g(new s()) || a && "[object WeakMap]" != g(new a())) && (g = function g(e) {
      var t = l(e),
          n = "[object Object]" == t ? e.constructor : void 0,
          r = n ? u(n) : "";
      if (r) switch (r) {
        case c:
          return "[object DataView]";

        case p:
          return "[object Map]";

        case f:
          return "[object Promise]";

        case h:
          return "[object Set]";

        case d:
          return "[object WeakMap]";
      }
      return t;
    }), e.exports = g;
  }, function (e, t, n) {
    var r = n(5)(n(0), "DataView");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(5)(n(0), "Promise");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(5)(n(0), "Set");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(5)(n(0), "WeakMap");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(40),
        i = n(18);

    e.exports = function (e) {
      for (var t = i(e), n = t.length; n--;) {
        var o = t[n],
            s = e[o];
        t[n] = [o, s, r(s)];
      }

      return t;
    };
  }, function (e, t, n) {
    var r = n(33),
        i = n(122),
        o = n(128),
        s = n(21),
        a = n(40),
        l = n(41),
        u = n(13),
        c = 1,
        p = 2;

    e.exports = function (e, t) {
      return s(e) && a(t) ? l(u(e), t) : function (n) {
        var s = i(n, e);
        return void 0 === s && s === t ? o(n, e) : r(t, s, c | p);
      };
    };
  }, function (e, t, n) {
    var r = n(42);

    e.exports = function (e, t, n) {
      var i = null == e ? void 0 : r(e, t);
      return void 0 === i ? n : i;
    };
  }, function (e, t, n) {
    var r = n(124),
        i = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
        o = /\\(\\)?/g,
        s = r(function (e) {
      var t = [];
      return 46 === e.charCodeAt(0) && t.push(""), e.replace(i, function (e, n, r, i) {
        t.push(r ? i.replace(o, "$1") : n || e);
      }), t;
    });
    e.exports = s;
  }, function (e, t, n) {
    var r = n(125),
        i = 500;

    e.exports = function (e) {
      var t = r(e, function (e) {
        return n.size === i && n.clear(), e;
      }),
          n = t.cache;
      return t;
    };
  }, function (e, t, n) {
    var r = n(17),
        i = "Expected a function";

    function o(e, t) {
      if ("function" != typeof e || null != t && "function" != typeof t) throw new TypeError(i);

      var n = function n() {
        var r = arguments,
            i = t ? t.apply(this, r) : r[0],
            o = n.cache;
        if (o.has(i)) return o.get(i);
        var s = e.apply(this, r);
        return n.cache = o.set(i, s) || o, s;
      };

      return n.cache = new (o.Cache || r)(), n;
    }

    o.Cache = r, e.exports = o;
  }, function (e, t, n) {
    var r = n(127);

    e.exports = function (e) {
      return null == e ? "" : r(e);
    };
  }, function (e, t, n) {
    var r = n(8),
        i = n(28),
        o = n(1),
        s = n(22),
        a = 1 / 0,
        l = r ? r.prototype : void 0,
        u = l ? l.toString : void 0;

    e.exports = function e(t) {
      if ("string" == typeof t) return t;
      if (o(t)) return i(t, e) + "";
      if (s(t)) return u ? u.call(t) : "";
      var n = t + "";
      return "0" == n && 1 / t == -a ? "-0" : n;
    };
  }, function (e, t, n) {
    var r = n(129),
        i = n(130);

    e.exports = function (e, t) {
      return null != e && i(e, t, r);
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return null != e && t in Object(e);
    };
  }, function (e, t, n) {
    var r = n(43),
        i = n(35),
        o = n(1),
        s = n(38),
        a = n(19),
        l = n(13);

    e.exports = function (e, t, n) {
      for (var u = -1, c = (t = r(t, e)).length, p = !1; ++u < c;) {
        var f = l(t[u]);
        if (!(p = null != e && n(e, f))) break;
        e = e[f];
      }

      return p || ++u != c ? p : !!(c = null == e ? 0 : e.length) && a(c) && s(f, c) && (o(e) || i(e));
    };
  }, function (e, t) {
    e.exports = function (e) {
      return e;
    };
  }, function (e, t, n) {
    var r = n(133),
        i = n(134),
        o = n(21),
        s = n(13);

    e.exports = function (e) {
      return o(e) ? r(s(e)) : i(e);
    };
  }, function (e, t) {
    e.exports = function (e) {
      return function (t) {
        return null == t ? void 0 : t[e];
      };
    };
  }, function (e, t, n) {
    var r = n(42);

    e.exports = function (e) {
      return function (t) {
        return r(t, e);
      };
    };
  }, function (e, t, n) {
    var r = n(136),
        i = n(20);

    e.exports = function (e, t) {
      var n = -1,
          o = i(e) ? Array(e.length) : [];
      return r(e, function (e, r, i) {
        o[++n] = t(e, r, i);
      }), o;
    };
  }, function (e, t, n) {
    var r = n(137),
        i = n(140)(r);
    e.exports = i;
  }, function (e, t, n) {
    var r = n(138),
        i = n(18);

    e.exports = function (e, t) {
      return e && r(e, t, i);
    };
  }, function (e, t, n) {
    var r = n(139)();
    e.exports = r;
  }, function (e, t) {
    e.exports = function (e) {
      return function (t, n, r) {
        for (var i = -1, o = Object(t), s = r(t), a = s.length; a--;) {
          var l = s[e ? a : ++i];
          if (!1 === n(o[l], l, o)) break;
        }

        return t;
      };
    };
  }, function (e, t, n) {
    var r = n(20);

    e.exports = function (e, t) {
      return function (n, i) {
        if (null == n) return n;
        if (!r(n)) return e(n, i);

        for (var o = n.length, s = t ? o : -1, a = Object(n); (t ? s-- : ++s < o) && !1 !== i(a[s], s, a);) {
          ;
        }

        return n;
      };
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(n(2)),
        o = function o() {
      return i.default.createElement("div", {
        className: "styleGuide-element styleGuide__panel",
        key: "404"
      }, "The variation you selected does not seem to exist :(");
    },
        s = function s(e) {
      return function (t) {
        return i.default.createElement(e.Wrapper, {
          Component: e.Component,
          componentProps: t
        });
      };
    };

    function a(e, t) {
      var n = e.name,
          r = e.description;
      return i.default.createElement("div", null, i.default.createElement("div", {
        className: "styleGuide-element"
      }, i.default.createElement("h3", null, n), i.default.createElement("div", {
        className: "styleGuideViewer__description",
        dangerouslySetInnerHTML: {
          __html: r
        }
      })), i.default.createElement("div", {
        className: "styleGuideViewer__item-container"
      }, t));
    }

    t.Variation =
    /*#__PURE__*/
    function (_i$default$PureCompon) {
      _inherits(_class, _i$default$PureCompon);

      function _class(e) {
        var _this;

        _classCallCheck(this, _class);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, e)), _this.state = {
          hasError: !1
        };
        return _this;
      }

      _createClass(_class, [{
        key: "render",
        value: function render() {
          if (!this.props.variation) return o();
          var _this$props = this.props,
              e = _this$props.component,
              t = _this$props.variation,
              n = _this$props.hideMeta;
          var r = e.Wrapper ? s(e) : e.Component;
          var l = t.name,
              u = t.description,
              c = t.props;
          return i.default.createElement("div", {
            key: l,
            className: "styleGuide__panel"
          }, this.state.hasError ? a(t, i.default.createElement("div", {
            className: "styleGuide-element",
            style: {
              padding: 20,
              textAlign: "center"
            }
          }, "❗️", i.default.createElement("strong", {
            style: {
              opacity: .5
            }
          }, i.default.createElement("br", null), "An error occurred within this component.", i.default.createElement("br", null), "Check the developer console for more information."))) : this.props.hideMeta ? i.default.createElement(r, Object.assign({}, c)) : a(t, i.default.createElement(r, Object.assign({}, c))));
        }
      }], [{
        key: "getDerivedStateFromError",
        value: function getDerivedStateFromError(e) {
          return {
            hasError: !0
          };
        }
      }]);

      return _class;
    }(i.default.PureComponent);
  }, function (e, t, n) {
    e.exports = n(143)();
  }, function (e, t, n) {
    "use strict";

    var r = n(144),
        i = n(145),
        o = n(146);

    e.exports = function () {
      function e(e, t, n, r, s, a) {
        a !== o && i(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t
      };
      return n.checkPropTypes = r, n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return function () {
        return e;
      };
    }

    var i = function i() {};

    i.thatReturns = r, i.thatReturnsFalse = r(!1), i.thatReturnsTrue = r(!0), i.thatReturnsNull = r(null), i.thatReturnsThis = function () {
      return this;
    }, i.thatReturnsArgument = function (e) {
      return e;
    }, e.exports = i;
  }, function (e, t, n) {
    "use strict";

    var r = function r(e) {};

    e.exports = function (e, t, n, i, o, s, a, l) {
      if (r(t), !e) {
        var u;
        if (void 0 === t) u = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var c = [n, i, o, s, a, l],
              p = 0;
          (u = new Error(t.replace(/%s/g, function () {
            return c[p++];
          }))).name = "Invariant Violation";
        }
        throw u.framesToPop = 1, u;
      }
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = r(n(2)),
        o = r(n(14)),
        s = new (r(n(6)).default)("styleGuideColorList");

    t.ColorList = function (e) {
      return i.default.createElement("ul", Object.assign({}, s({
        extra: "styleGuide-element"
      })), o.default(e, function (e, t) {
        return i.default.createElement("li", Object.assign({
          key: t
        }, s("item")), i.default.createElement("div", Object.assign({}, s("preview", void 0, e))), i.default.createElement("div", Object.assign({}, s("name")), t), i.default.createElement("div", Object.assign({}, s("className")), i.default.createElement("code", null, e)));
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = r(n(2)),
        o = r(n(14)),
        s = new (r(n(6)).default)("styleGuideTypeList");

    t.TypeList = function (e) {
      return i.default.createElement("ul", Object.assign({}, s()), o.default(e, function (e, t) {
        return i.default.createElement("li", Object.assign({
          key: t
        }, s("item")), i.default.createElement("div", Object.assign({}, s("preview", void 0, e)), t), i.default.createElement("div", Object.assign({}, s("className")), i.default.createElement("code", null, e)));
      }));
    };
  }]);
});